(function(){"use strict";try{if(typeof document<"u"){var o=document.createElement("style");o.appendChild(document.createTextNode('@import"https://fonts.googleapis.com/css2?family=Poppins:wght@400;500&display=swap";input{box-sizing:border-box}._container_1c03y_8{position:relative;display:inline-block;height:50px;font-family:Poppins,sans-serif}._dropdown_1c03y_15{background:#e7e7e7;border-radius:5px;display:flex;height:80%;width:100px;position:relative;padding:0 10px;align-items:center;cursor:pointer}._dropdown_items_wrapper_1c03y_27{position:absolute;margin-top:18px;transition:all .5s;background:#fff;box-shadow:#0000003d 0 3px 8px;border-radius:5px;width:250px;z-index:10}._dropdown_items_1c03y_27{padding:10px;height:200px;overflow-y:scroll}._input_wrapper_1c03y_44{padding-top:10px;position:relative;text-align:center}._country_search_1c03y_50{outline:none;border-color:#d3cecebf;border-style:solid;border-width:1px;border-radius:3px;background:#f2f2f2;color:#484848;padding:8px;width:92%}._country_search_1c03y_50::placeholder{font-family:Poppins;font-size:13px;color:#484848}._dropdown_items_1c03y_27::-webkit-scrollbar{width:8px}._dropdown_items_1c03y_27::-webkit-scrollbar-track{background:#fff}._dropdown_items_1c03y_27::-webkit-scrollbar-thumb{background:#888;border-radius:2px}._dropdown_items_1c03y_27::-webkit-scrollbar-thumb:hover{background:#696969}._dropdown_item_1c03y_27{display:flex;cursor:pointer;padding:10px 5px;border-radius:3px}._dropdown_item_1c03y_27:hover{background:#f0f0f0}._dropdown_item_title_1c03y_100{margin-left:15px;margin-top:-2px;font-size:13px;font-weight:500;text-align:left;color:#484848}._selected_country_1c03y_109{font-size:15px;font-weight:500;color:#484848;margin-left:15px}._country_flag_1c03y_116{height:15px;width:22px;border-radius:2px}')),document.head.appendChild(o)}}catch(e){console.error("vite-plugin-css-injected-by-js",e)}})();
import ka, { useState as oa, useRef as he, useEffect as Pa } from "react";
var ia = { exports: {} }, j = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ba;
function fe() {
  if (Ba) return j;
  Ba = 1;
  var R = ka, M = Symbol.for("react.element"), y = Symbol.for("react.fragment"), S = Object.prototype.hasOwnProperty, h = R.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, w = { key: !0, ref: !0, __self: !0, __source: !0 };
  function b(E, d, P) {
    var g, v = {}, D = null, F = null;
    P !== void 0 && (D = "" + P), d.key !== void 0 && (D = "" + d.key), d.ref !== void 0 && (F = d.ref);
    for (g in d) S.call(d, g) && !w.hasOwnProperty(g) && (v[g] = d[g]);
    if (E && E.defaultProps) for (g in d = E.defaultProps, d) v[g] === void 0 && (v[g] = d[g]);
    return { $$typeof: M, type: E, key: D, ref: F, props: v, _owner: h.current };
  }
  return j.Fragment = y, j.jsx = b, j.jsxs = b, j;
}
var $ = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var wa;
function ye() {
  return wa || (wa = 1, process.env.NODE_ENV !== "production" && function() {
    var R = ka, M = Symbol.for("react.element"), y = Symbol.for("react.portal"), S = Symbol.for("react.fragment"), h = Symbol.for("react.strict_mode"), w = Symbol.for("react.profiler"), b = Symbol.for("react.provider"), E = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), P = Symbol.for("react.suspense"), g = Symbol.for("react.suspense_list"), v = Symbol.for("react.memo"), D = Symbol.for("react.lazy"), F = Symbol.for("react.offscreen"), o = Symbol.iterator, U = "@@iterator";
    function O(a) {
      if (a === null || typeof a != "object")
        return null;
      var e = o && a[o] || a[U];
      return typeof e == "function" ? e : null;
    }
    var B = R.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function p(a) {
      {
        for (var e = arguments.length, n = new Array(e > 1 ? e - 1 : 0), l = 1; l < e; l++)
          n[l - 1] = arguments[l];
        Fa("error", a, n);
      }
    }
    function Fa(a, e, n) {
      {
        var l = B.ReactDebugCurrentFrame, s = l.getStackAddendum();
        s !== "" && (e += "%s", n = n.concat([s]));
        var c = n.map(function(r) {
          return String(r);
        });
        c.unshift("Warning: " + e), Function.prototype.apply.call(console[a], console, c);
      }
    }
    var _a = !1, Ia = !1, Oa = !1, Ga = !1, La = !1, ra;
    ra = Symbol.for("react.module.reference");
    function Ka(a) {
      return !!(typeof a == "string" || typeof a == "function" || a === S || a === w || La || a === h || a === P || a === g || Ga || a === F || _a || Ia || Oa || typeof a == "object" && a !== null && (a.$$typeof === D || a.$$typeof === v || a.$$typeof === b || a.$$typeof === E || a.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      a.$$typeof === ra || a.getModuleId !== void 0));
    }
    function ja(a, e, n) {
      var l = a.displayName;
      if (l)
        return l;
      var s = e.displayName || e.name || "";
      return s !== "" ? n + "(" + s + ")" : n;
    }
    function sa(a) {
      return a.displayName || "Context";
    }
    function z(a) {
      if (a == null)
        return null;
      if (typeof a.tag == "number" && p("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof a == "function")
        return a.displayName || a.name || null;
      if (typeof a == "string")
        return a;
      switch (a) {
        case S:
          return "Fragment";
        case y:
          return "Portal";
        case w:
          return "Profiler";
        case h:
          return "StrictMode";
        case P:
          return "Suspense";
        case g:
          return "SuspenseList";
      }
      if (typeof a == "object")
        switch (a.$$typeof) {
          case E:
            var e = a;
            return sa(e) + ".Consumer";
          case b:
            var n = a;
            return sa(n._context) + ".Provider";
          case d:
            return ja(a, a.render, "ForwardRef");
          case v:
            var l = a.displayName || null;
            return l !== null ? l : z(a.type) || "Memo";
          case D: {
            var s = a, c = s._payload, r = s._init;
            try {
              return z(r(c));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var N = Object.assign, G = 0, ca, ta, ma, da, ga, pa, Ca;
    function ua() {
    }
    ua.__reactDisabledLog = !0;
    function $a() {
      {
        if (G === 0) {
          ca = console.log, ta = console.info, ma = console.warn, da = console.error, ga = console.group, pa = console.groupCollapsed, Ca = console.groupEnd;
          var a = {
            configurable: !0,
            enumerable: !0,
            value: ua,
            writable: !0
          };
          Object.defineProperties(console, {
            info: a,
            log: a,
            warn: a,
            error: a,
            group: a,
            groupCollapsed: a,
            groupEnd: a
          });
        }
        G++;
      }
    }
    function xa() {
      {
        if (G--, G === 0) {
          var a = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: N({}, a, {
              value: ca
            }),
            info: N({}, a, {
              value: ta
            }),
            warn: N({}, a, {
              value: ma
            }),
            error: N({}, a, {
              value: da
            }),
            group: N({}, a, {
              value: ga
            }),
            groupCollapsed: N({}, a, {
              value: pa
            }),
            groupEnd: N({}, a, {
              value: Ca
            })
          });
        }
        G < 0 && p("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Y = B.ReactCurrentDispatcher, Z;
    function x(a, e, n) {
      {
        if (Z === void 0)
          try {
            throw Error();
          } catch (s) {
            var l = s.stack.trim().match(/\n( *(at )?)/);
            Z = l && l[1] || "";
          }
        return `
` + Z + a;
      }
    }
    var J = !1, V;
    {
      var Va = typeof WeakMap == "function" ? WeakMap : Map;
      V = new Va();
    }
    function ha(a, e) {
      if (!a || J)
        return "";
      {
        var n = V.get(a);
        if (n !== void 0)
          return n;
      }
      var l;
      J = !0;
      var s = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var c;
      c = Y.current, Y.current = null, $a();
      try {
        if (e) {
          var r = function() {
            throw Error();
          };
          if (Object.defineProperty(r.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(r, []);
            } catch (f) {
              l = f;
            }
            Reflect.construct(a, [], r);
          } else {
            try {
              r.call();
            } catch (f) {
              l = f;
            }
            a.call(r.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (f) {
            l = f;
          }
          a();
        }
      } catch (f) {
        if (f && l && typeof f.stack == "string") {
          for (var i = f.stack.split(`
`), C = l.stack.split(`
`), t = i.length - 1, m = C.length - 1; t >= 1 && m >= 0 && i[t] !== C[m]; )
            m--;
          for (; t >= 1 && m >= 0; t--, m--)
            if (i[t] !== C[m]) {
              if (t !== 1 || m !== 1)
                do
                  if (t--, m--, m < 0 || i[t] !== C[m]) {
                    var T = `
` + i[t].replace(" at new ", " at ");
                    return a.displayName && T.includes("<anonymous>") && (T = T.replace("<anonymous>", a.displayName)), typeof a == "function" && V.set(a, T), T;
                  }
                while (t >= 1 && m >= 0);
              break;
            }
        }
      } finally {
        J = !1, Y.current = c, xa(), Error.prepareStackTrace = s;
      }
      var I = a ? a.displayName || a.name : "", k = I ? x(I) : "";
      return typeof a == "function" && V.set(a, k), k;
    }
    function Wa(a, e, n) {
      return ha(a, !1);
    }
    function Ha(a) {
      var e = a.prototype;
      return !!(e && e.isReactComponent);
    }
    function W(a, e, n) {
      if (a == null)
        return "";
      if (typeof a == "function")
        return ha(a, Ha(a));
      if (typeof a == "string")
        return x(a);
      switch (a) {
        case P:
          return x("Suspense");
        case g:
          return x("SuspenseList");
      }
      if (typeof a == "object")
        switch (a.$$typeof) {
          case d:
            return Wa(a.render);
          case v:
            return W(a.type, e, n);
          case D: {
            var l = a, s = l._payload, c = l._init;
            try {
              return W(c(s), e, n);
            } catch {
            }
          }
        }
      return "";
    }
    var L = Object.prototype.hasOwnProperty, fa = {}, ya = B.ReactDebugCurrentFrame;
    function H(a) {
      if (a) {
        var e = a._owner, n = W(a.type, a._source, e ? e.type : null);
        ya.setExtraStackFrame(n);
      } else
        ya.setExtraStackFrame(null);
    }
    function Ya(a, e, n, l, s) {
      {
        var c = Function.call.bind(L);
        for (var r in a)
          if (c(a, r)) {
            var i = void 0;
            try {
              if (typeof a[r] != "function") {
                var C = Error((l || "React class") + ": " + n + " type `" + r + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof a[r] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw C.name = "Invariant Violation", C;
              }
              i = a[r](e, r, l, n, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (t) {
              i = t;
            }
            i && !(i instanceof Error) && (H(s), p("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", l || "React class", n, r, typeof i), H(null)), i instanceof Error && !(i.message in fa) && (fa[i.message] = !0, H(s), p("Failed %s type: %s", n, i.message), H(null));
          }
      }
    }
    var Za = Array.isArray;
    function X(a) {
      return Za(a);
    }
    function Ja(a) {
      {
        var e = typeof Symbol == "function" && Symbol.toStringTag, n = e && a[Symbol.toStringTag] || a.constructor.name || "Object";
        return n;
      }
    }
    function Xa(a) {
      try {
        return Ta(a), !1;
      } catch {
        return !0;
      }
    }
    function Ta(a) {
      return "" + a;
    }
    function ba(a) {
      if (Xa(a))
        return p("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Ja(a)), Ta(a);
    }
    var K = B.ReactCurrentOwner, qa = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, va, Ua, q;
    q = {};
    function Qa(a) {
      if (L.call(a, "ref")) {
        var e = Object.getOwnPropertyDescriptor(a, "ref").get;
        if (e && e.isReactWarning)
          return !1;
      }
      return a.ref !== void 0;
    }
    function ae(a) {
      if (L.call(a, "key")) {
        var e = Object.getOwnPropertyDescriptor(a, "key").get;
        if (e && e.isReactWarning)
          return !1;
      }
      return a.key !== void 0;
    }
    function ee(a, e) {
      if (typeof a.ref == "string" && K.current && e && K.current.stateNode !== e) {
        var n = z(K.current.type);
        q[n] || (p('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', z(K.current.type), a.ref), q[n] = !0);
      }
    }
    function ne(a, e) {
      {
        var n = function() {
          va || (va = !0, p("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", e));
        };
        n.isReactWarning = !0, Object.defineProperty(a, "key", {
          get: n,
          configurable: !0
        });
      }
    }
    function oe(a, e) {
      {
        var n = function() {
          Ua || (Ua = !0, p("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", e));
        };
        n.isReactWarning = !0, Object.defineProperty(a, "ref", {
          get: n,
          configurable: !0
        });
      }
    }
    var le = function(a, e, n, l, s, c, r) {
      var i = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: M,
        // Built-in properties that belong on the element
        type: a,
        key: e,
        ref: n,
        props: r,
        // Record the component responsible for creating this element.
        _owner: c
      };
      return i._store = {}, Object.defineProperty(i._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(i, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: l
      }), Object.defineProperty(i, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: s
      }), Object.freeze && (Object.freeze(i.props), Object.freeze(i)), i;
    };
    function ie(a, e, n, l, s) {
      {
        var c, r = {}, i = null, C = null;
        n !== void 0 && (ba(n), i = "" + n), ae(e) && (ba(e.key), i = "" + e.key), Qa(e) && (C = e.ref, ee(e, s));
        for (c in e)
          L.call(e, c) && !qa.hasOwnProperty(c) && (r[c] = e[c]);
        if (a && a.defaultProps) {
          var t = a.defaultProps;
          for (c in t)
            r[c] === void 0 && (r[c] = t[c]);
        }
        if (i || C) {
          var m = typeof a == "function" ? a.displayName || a.name || "Unknown" : a;
          i && ne(r, m), C && oe(r, m);
        }
        return le(a, i, C, s, l, K.current, r);
      }
    }
    var Q = B.ReactCurrentOwner, Aa = B.ReactDebugCurrentFrame;
    function _(a) {
      if (a) {
        var e = a._owner, n = W(a.type, a._source, e ? e.type : null);
        Aa.setExtraStackFrame(n);
      } else
        Aa.setExtraStackFrame(null);
    }
    var aa;
    aa = !1;
    function ea(a) {
      return typeof a == "object" && a !== null && a.$$typeof === M;
    }
    function Sa() {
      {
        if (Q.current) {
          var a = z(Q.current.type);
          if (a)
            return `

Check the render method of \`` + a + "`.";
        }
        return "";
      }
    }
    function re(a) {
      return "";
    }
    var Ea = {};
    function se(a) {
      {
        var e = Sa();
        if (!e) {
          var n = typeof a == "string" ? a : a.displayName || a.name;
          n && (e = `

Check the top-level render call using <` + n + ">.");
        }
        return e;
      }
    }
    function za(a, e) {
      {
        if (!a._store || a._store.validated || a.key != null)
          return;
        a._store.validated = !0;
        var n = se(e);
        if (Ea[n])
          return;
        Ea[n] = !0;
        var l = "";
        a && a._owner && a._owner !== Q.current && (l = " It was passed a child from " + z(a._owner.type) + "."), _(a), p('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', n, l), _(null);
      }
    }
    function Ra(a, e) {
      {
        if (typeof a != "object")
          return;
        if (X(a))
          for (var n = 0; n < a.length; n++) {
            var l = a[n];
            ea(l) && za(l, e);
          }
        else if (ea(a))
          a._store && (a._store.validated = !0);
        else if (a) {
          var s = O(a);
          if (typeof s == "function" && s !== a.entries)
            for (var c = s.call(a), r; !(r = c.next()).done; )
              ea(r.value) && za(r.value, e);
        }
      }
    }
    function ce(a) {
      {
        var e = a.type;
        if (e == null || typeof e == "string")
          return;
        var n;
        if (typeof e == "function")
          n = e.propTypes;
        else if (typeof e == "object" && (e.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        e.$$typeof === v))
          n = e.propTypes;
        else
          return;
        if (n) {
          var l = z(e);
          Ya(n, a.props, "prop", l, a);
        } else if (e.PropTypes !== void 0 && !aa) {
          aa = !0;
          var s = z(e);
          p("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", s || "Unknown");
        }
        typeof e.getDefaultProps == "function" && !e.getDefaultProps.isReactClassApproved && p("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function te(a) {
      {
        for (var e = Object.keys(a.props), n = 0; n < e.length; n++) {
          var l = e[n];
          if (l !== "children" && l !== "key") {
            _(a), p("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", l), _(null);
            break;
          }
        }
        a.ref !== null && (_(a), p("Invalid attribute `ref` supplied to `React.Fragment`."), _(null));
      }
    }
    var Ma = {};
    function Da(a, e, n, l, s, c) {
      {
        var r = Ka(a);
        if (!r) {
          var i = "";
          (a === void 0 || typeof a == "object" && a !== null && Object.keys(a).length === 0) && (i += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var C = re();
          C ? i += C : i += Sa();
          var t;
          a === null ? t = "null" : X(a) ? t = "array" : a !== void 0 && a.$$typeof === M ? (t = "<" + (z(a.type) || "Unknown") + " />", i = " Did you accidentally export a JSX literal instead of a component?") : t = typeof a, p("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", t, i);
        }
        var m = ie(a, e, n, s, c);
        if (m == null)
          return m;
        if (r) {
          var T = e.children;
          if (T !== void 0)
            if (l)
              if (X(T)) {
                for (var I = 0; I < T.length; I++)
                  Ra(T[I], a);
                Object.freeze && Object.freeze(T);
              } else
                p("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Ra(T, a);
        }
        if (L.call(e, "key")) {
          var k = z(a), f = Object.keys(e).filter(function(ue) {
            return ue !== "key";
          }), na = f.length > 0 ? "{key: someKey, " + f.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Ma[k + na]) {
            var Ce = f.length > 0 ? "{" + f.join(": ..., ") + ": ...}" : "{}";
            p(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, na, k, Ce, k), Ma[k + na] = !0;
          }
        }
        return a === S ? te(m) : ce(m), m;
      }
    }
    function me(a, e, n) {
      return Da(a, e, n, !0);
    }
    function de(a, e, n) {
      return Da(a, e, n, !1);
    }
    var ge = de, pe = me;
    $.Fragment = S, $.jsx = ge, $.jsxs = pe;
  }()), $;
}
process.env.NODE_ENV === "production" ? ia.exports = fe() : ia.exports = ye();
var u = ia.exports;
const Te = [
  {
    name: "Afghanistan",
    alpha2Code: "AF",
    alpha3Code: "AFG",
    callingCodes: [
      "93"
    ],
    capital: "Kabul",
    region: "Asia",
    latlng: [
      33,
      65
    ],
    demonym: "Afghan",
    timezones: [
      "UTC+04:30"
    ],
    flag: "https://upload.wikimedia.org/wikipedia/commons/5/5c/Flag_of_the_Taliban.svg",
    currencies: [
      {
        code: "AFN",
        name: "Afghan afghani",
        symbol: "؋"
      }
    ]
  },
  {
    name: "Åland Islands",
    alpha2Code: "AX",
    alpha3Code: "ALA",
    callingCodes: [
      "358"
    ],
    capital: "Mariehamn",
    region: "Europe",
    latlng: [
      60.116667,
      19.9
    ],
    demonym: "Ålandish",
    timezones: [
      "UTC+02:00"
    ],
    flag: "https://flagcdn.com/ax.svg",
    currencies: [
      {
        code: "EUR",
        name: "Euro",
        symbol: "€"
      }
    ]
  },
  {
    name: "Albania",
    alpha2Code: "AL",
    alpha3Code: "ALB",
    callingCodes: [
      "355"
    ],
    capital: "Tirana",
    region: "Europe",
    latlng: [
      41,
      20
    ],
    demonym: "Albanian",
    timezones: [
      "UTC+01:00"
    ],
    flag: "https://flagcdn.com/al.svg",
    currencies: [
      {
        code: "ALL",
        name: "Albanian lek",
        symbol: "L"
      }
    ]
  },
  {
    name: "Algeria",
    alpha2Code: "DZ",
    alpha3Code: "DZA",
    callingCodes: [
      "213"
    ],
    capital: "Algiers",
    region: "Africa",
    latlng: [
      28,
      3
    ],
    demonym: "Algerian",
    timezones: [
      "UTC+01:00"
    ],
    flag: "https://flagcdn.com/dz.svg",
    currencies: [
      {
        code: "DZD",
        name: "Algerian dinar",
        symbol: "د.ج"
      }
    ]
  },
  {
    name: "American Samoa",
    alpha2Code: "AS",
    alpha3Code: "ASM",
    callingCodes: [
      "1"
    ],
    capital: "Pago Pago",
    region: "Oceania",
    latlng: [
      -14.33333333,
      -170
    ],
    demonym: "American Samoan",
    timezones: [
      "UTC-11:00"
    ],
    flag: "https://flagcdn.com/as.svg",
    currencies: [
      {
        code: "USD",
        name: "United States Dollar",
        symbol: "$"
      }
    ]
  },
  {
    name: "Andorra",
    alpha2Code: "AD",
    alpha3Code: "AND",
    callingCodes: [
      "376"
    ],
    capital: "Andorra la Vella",
    region: "Europe",
    latlng: [
      42.5,
      1.5
    ],
    demonym: "Andorran",
    timezones: [
      "UTC+01:00"
    ],
    flag: "https://flagcdn.com/ad.svg",
    currencies: [
      {
        code: "EUR",
        name: "Euro",
        symbol: "€"
      }
    ]
  },
  {
    name: "Angola",
    alpha2Code: "AO",
    alpha3Code: "AGO",
    callingCodes: [
      "244"
    ],
    capital: "Luanda",
    region: "Africa",
    latlng: [
      -12.5,
      18.5
    ],
    demonym: "Angolan",
    timezones: [
      "UTC+01:00"
    ],
    flag: "https://flagcdn.com/ao.svg",
    currencies: [
      {
        code: "AOA",
        name: "Angolan kwanza",
        symbol: "Kz"
      }
    ]
  },
  {
    name: "Anguilla",
    alpha2Code: "AI",
    alpha3Code: "AIA",
    callingCodes: [
      "1"
    ],
    capital: "The Valley",
    region: "Americas",
    latlng: [
      18.25,
      -63.16666666
    ],
    demonym: "Anguillian",
    timezones: [
      "UTC-04:00"
    ],
    flag: "https://flagcdn.com/ai.svg",
    currencies: [
      {
        code: "XCD",
        name: "East Caribbean dollar",
        symbol: "$"
      }
    ]
  },
  {
    name: "Antarctica",
    alpha2Code: "AQ",
    alpha3Code: "ATA",
    callingCodes: [
      "672"
    ],
    capital: null,
    region: "Polar",
    latlng: [
      -74.65,
      4.48
    ],
    demonym: "Antarctic",
    timezones: [
      "UTC-03:00",
      "UTC+03:00",
      "UTC+05:00",
      "UTC+06:00",
      "UTC+07:00",
      "UTC+08:00",
      "UTC+10:00",
      "UTC+12:00"
    ],
    flag: "https://flagcdn.com/aq.svg",
    currencies: null
  },
  {
    name: "Antigua and Barbuda",
    alpha2Code: "AG",
    alpha3Code: "ATG",
    callingCodes: [
      "1"
    ],
    capital: "Saint John's",
    region: "Americas",
    latlng: [
      17.05,
      -61.8
    ],
    demonym: "Antiguan, Barbudan",
    timezones: [
      "UTC-04:00"
    ],
    flag: "https://flagcdn.com/ag.svg",
    currencies: [
      {
        code: "XCD",
        name: "East Caribbean dollar",
        symbol: "$"
      }
    ]
  },
  {
    name: "Argentina",
    alpha2Code: "AR",
    alpha3Code: "ARG",
    callingCodes: [
      "54"
    ],
    capital: "Buenos Aires",
    region: "Americas",
    latlng: [
      -34,
      -64
    ],
    demonym: "Argentinean",
    timezones: [
      "UTC-03:00"
    ],
    flag: "https://flagcdn.com/ar.svg",
    currencies: [
      {
        code: "ARS",
        name: "Argentine peso",
        symbol: "$"
      }
    ]
  },
  {
    name: "Armenia",
    alpha2Code: "AM",
    alpha3Code: "ARM",
    callingCodes: [
      "374"
    ],
    capital: "Yerevan",
    region: "Asia",
    latlng: [
      40,
      45
    ],
    demonym: "Armenian",
    timezones: [
      "UTC+04:00"
    ],
    flag: "https://flagcdn.com/am.svg",
    currencies: [
      {
        code: "AMD",
        name: "Armenian dram",
        symbol: "֏"
      }
    ]
  },
  {
    name: "Aruba",
    alpha2Code: "AW",
    alpha3Code: "ABW",
    callingCodes: [
      "297"
    ],
    capital: "Oranjestad",
    region: "Americas",
    latlng: [
      12.5,
      -69.96666666
    ],
    demonym: "Aruban",
    timezones: [
      "UTC-04:00"
    ],
    flag: "https://flagcdn.com/aw.svg",
    currencies: [
      {
        code: "AWG",
        name: "Aruban florin",
        symbol: "ƒ"
      }
    ]
  },
  {
    name: "Australia",
    alpha2Code: "AU",
    alpha3Code: "AUS",
    callingCodes: [
      "61"
    ],
    capital: "Canberra",
    region: "Oceania",
    latlng: [
      -27,
      133
    ],
    demonym: "Australian",
    timezones: [
      "UTC+05:00",
      "UTC+06:30",
      "UTC+07:00",
      "UTC+08:00",
      "UTC+09:30",
      "UTC+10:00",
      "UTC+10:30",
      "UTC+11:30"
    ],
    flag: "https://flagcdn.com/au.svg",
    currencies: [
      {
        code: "AUD",
        name: "Australian dollar",
        symbol: "$"
      }
    ]
  },
  {
    name: "Austria",
    alpha2Code: "AT",
    alpha3Code: "AUT",
    callingCodes: [
      "43"
    ],
    capital: "Vienna",
    region: "Europe",
    latlng: [
      47.33333333,
      13.33333333
    ],
    demonym: "Austrian",
    timezones: [
      "UTC+01:00"
    ],
    flag: "https://flagcdn.com/at.svg",
    currencies: [
      {
        code: "EUR",
        name: "Euro",
        symbol: "€"
      }
    ]
  },
  {
    name: "Azerbaijan",
    alpha2Code: "AZ",
    alpha3Code: "AZE",
    callingCodes: [
      "994"
    ],
    capital: "Baku",
    region: "Asia",
    latlng: [
      40.5,
      47.5
    ],
    demonym: "Azerbaijani",
    timezones: [
      "UTC+04:00"
    ],
    flag: "https://flagcdn.com/az.svg",
    currencies: [
      {
        code: "AZN",
        name: "Azerbaijani manat",
        symbol: "₼"
      }
    ]
  },
  {
    name: "Bahamas",
    alpha2Code: "BS",
    alpha3Code: "BHS",
    callingCodes: [
      "1"
    ],
    capital: "Nassau",
    region: "Americas",
    latlng: [
      24.25,
      -76
    ],
    demonym: "Bahamian",
    timezones: [
      "UTC-05:00"
    ],
    flag: "https://flagcdn.com/bs.svg",
    currencies: [
      {
        code: "BSD",
        name: "Bahamian dollar",
        symbol: "$"
      }
    ]
  },
  {
    name: "Bahrain",
    alpha2Code: "BH",
    alpha3Code: "BHR",
    callingCodes: [
      "973"
    ],
    capital: "Manama",
    region: "Asia",
    latlng: [
      26,
      50.55
    ],
    demonym: "Bahraini",
    timezones: [
      "UTC+03:00"
    ],
    flag: "https://flagcdn.com/bh.svg",
    currencies: [
      {
        code: "BHD",
        name: "Bahraini dinar",
        symbol: ".د.ب"
      }
    ]
  },
  {
    name: "Bangladesh",
    alpha2Code: "BD",
    alpha3Code: "BGD",
    callingCodes: [
      "880"
    ],
    capital: "Dhaka",
    region: "Asia",
    latlng: [
      24,
      90
    ],
    demonym: "Bangladeshi",
    timezones: [
      "UTC+06:00"
    ],
    flag: "https://flagcdn.com/bd.svg",
    currencies: [
      {
        code: "BDT",
        name: "Bangladeshi taka",
        symbol: "৳"
      }
    ]
  },
  {
    name: "Barbados",
    alpha2Code: "BB",
    alpha3Code: "BRB",
    callingCodes: [
      "1"
    ],
    capital: "Bridgetown",
    region: "Americas",
    latlng: [
      13.16666666,
      -59.53333333
    ],
    demonym: "Barbadian",
    timezones: [
      "UTC-04:00"
    ],
    flag: "https://flagcdn.com/bb.svg",
    currencies: [
      {
        code: "BBD",
        name: "Barbadian dollar",
        symbol: "$"
      }
    ]
  },
  {
    name: "Belarus",
    alpha2Code: "BY",
    alpha3Code: "BLR",
    callingCodes: [
      "375"
    ],
    capital: "Minsk",
    region: "Europe",
    latlng: [
      53,
      28
    ],
    demonym: "Belarusian",
    timezones: [
      "UTC+03:00"
    ],
    flag: "https://flagcdn.com/by.svg",
    currencies: [
      {
        code: "BYN",
        name: "New Belarusian ruble",
        symbol: "Br"
      },
      {
        code: "BYR",
        name: "Old Belarusian ruble",
        symbol: "Br"
      }
    ]
  },
  {
    name: "Belgium",
    alpha2Code: "BE",
    alpha3Code: "BEL",
    callingCodes: [
      "32"
    ],
    capital: "Brussels",
    region: "Europe",
    latlng: [
      50.83333333,
      4
    ],
    demonym: "Belgian",
    timezones: [
      "UTC+01:00"
    ],
    flag: "https://flagcdn.com/be.svg",
    currencies: [
      {
        code: "EUR",
        name: "Euro",
        symbol: "€"
      }
    ]
  },
  {
    name: "Belize",
    alpha2Code: "BZ",
    alpha3Code: "BLZ",
    callingCodes: [
      "501"
    ],
    capital: "Belmopan",
    region: "Americas",
    latlng: [
      17.25,
      -88.75
    ],
    demonym: "Belizean",
    timezones: [
      "UTC-06:00"
    ],
    flag: "https://flagcdn.com/bz.svg",
    currencies: [
      {
        code: "BZD",
        name: "Belize dollar",
        symbol: "$"
      }
    ]
  },
  {
    name: "Benin",
    alpha2Code: "BJ",
    alpha3Code: "BEN",
    callingCodes: [
      "229"
    ],
    capital: "Porto-Novo",
    region: "Africa",
    latlng: [
      9.5,
      2.25
    ],
    demonym: "Beninese",
    timezones: [
      "UTC+01:00"
    ],
    flag: "https://flagcdn.com/bj.svg",
    currencies: [
      {
        code: "XOF",
        name: "West African CFA franc",
        symbol: "Fr"
      }
    ]
  },
  {
    name: "Bermuda",
    alpha2Code: "BM",
    alpha3Code: "BMU",
    callingCodes: [
      "1"
    ],
    capital: "Hamilton",
    region: "Americas",
    latlng: [
      32.33333333,
      -64.75
    ],
    demonym: "Bermudian",
    timezones: [
      "UTC-04:00"
    ],
    flag: "https://flagcdn.com/bm.svg",
    currencies: [
      {
        code: "BMD",
        name: "Bermudian dollar",
        symbol: "$"
      }
    ]
  },
  {
    name: "Bhutan",
    alpha2Code: "BT",
    alpha3Code: "BTN",
    callingCodes: [
      "975"
    ],
    capital: "Thimphu",
    region: "Asia",
    latlng: [
      27.5,
      90.5
    ],
    demonym: "Bhutanese",
    timezones: [
      "UTC+06:00"
    ],
    flag: "https://flagcdn.com/bt.svg",
    currencies: [
      {
        code: "BTN",
        name: "Bhutanese ngultrum",
        symbol: "Nu."
      },
      {
        code: "INR",
        name: "Indian rupee",
        symbol: "₹"
      }
    ]
  },
  {
    name: "Bolivia (Plurinational State of)",
    alpha2Code: "BO",
    alpha3Code: "BOL",
    callingCodes: [
      "591"
    ],
    capital: "Sucre",
    region: "Americas",
    latlng: [
      -17,
      -65
    ],
    demonym: "Bolivian",
    timezones: [
      "UTC-04:00"
    ],
    flag: "https://flagcdn.com/bo.svg",
    currencies: [
      {
        code: "BOB",
        name: "Bolivian boliviano",
        symbol: "Bs."
      }
    ]
  },
  {
    name: "Bonaire, Sint Eustatius and Saba",
    alpha2Code: "BQ",
    alpha3Code: "BES",
    callingCodes: [
      "599"
    ],
    capital: "Kralendijk",
    region: "Americas",
    latlng: [
      12.15,
      -68.266667
    ],
    demonym: "Dutch",
    timezones: [
      "UTC-04:00"
    ],
    flag: "https://flagcdn.com/bq.svg",
    currencies: [
      {
        code: "USD",
        name: "United States dollar",
        symbol: "$"
      }
    ]
  },
  {
    name: "Bosnia and Herzegovina",
    alpha2Code: "BA",
    alpha3Code: "BIH",
    callingCodes: [
      "387"
    ],
    capital: "Sarajevo",
    region: "Europe",
    latlng: [
      44,
      18
    ],
    demonym: "Bosnian, Herzegovinian",
    timezones: [
      "UTC+01:00"
    ],
    flag: "https://flagcdn.com/ba.svg",
    currencies: [
      {
        code: "BAM",
        name: "Bosnia and Herzegovina convertible mark",
        symbol: "KM"
      }
    ]
  },
  {
    name: "Botswana",
    alpha2Code: "BW",
    alpha3Code: "BWA",
    callingCodes: [
      "267"
    ],
    capital: "Gaborone",
    region: "Africa",
    latlng: [
      -22,
      24
    ],
    demonym: "Motswana",
    timezones: [
      "UTC+02:00"
    ],
    flag: "https://flagcdn.com/bw.svg",
    currencies: [
      {
        code: "BWP",
        name: "Botswana pula",
        symbol: "P"
      }
    ]
  },
  {
    name: "Bouvet Island",
    alpha2Code: "BV",
    alpha3Code: "BVT",
    callingCodes: [
      "47"
    ],
    capital: null,
    region: "Antarctic Ocean",
    latlng: [
      -54.43333333,
      3.4
    ],
    demonym: "Norwegian",
    timezones: [
      "UTC+01:00"
    ],
    flag: "https://flagcdn.com/bv.svg",
    currencies: [
      {
        code: "NOK",
        name: "Norwegian krone",
        symbol: "kr"
      }
    ]
  },
  {
    name: "Brazil",
    alpha2Code: "BR",
    alpha3Code: "BRA",
    callingCodes: [
      "55"
    ],
    capital: "Brasília",
    region: "Americas",
    latlng: [
      -10,
      -55
    ],
    demonym: "Brazilian",
    timezones: [
      "UTC-05:00",
      "UTC-04:00",
      "UTC-03:00",
      "UTC-02:00"
    ],
    flag: "https://flagcdn.com/br.svg",
    currencies: [
      {
        code: "BRL",
        name: "Brazilian real",
        symbol: "R$"
      }
    ]
  },
  {
    name: "British Indian Ocean Territory",
    alpha2Code: "IO",
    alpha3Code: "IOT",
    callingCodes: [
      "246"
    ],
    capital: "Diego Garcia",
    region: "Africa",
    latlng: [
      -6,
      71.5
    ],
    demonym: "Indian",
    timezones: [
      "UTC+06:00"
    ],
    flag: "https://flagcdn.com/io.svg",
    currencies: [
      {
        code: "USD",
        name: "United States dollar",
        symbol: "$"
      }
    ]
  },
  {
    name: "United States Minor Outlying Islands",
    alpha2Code: "UM",
    alpha3Code: "UMI",
    callingCodes: [
      "246"
    ],
    capital: null,
    region: "Americas",
    latlng: null,
    demonym: "American",
    timezones: [
      "UTC-11:00",
      "UTC-10:00",
      "UTC+12:00"
    ],
    flag: "https://flagcdn.com/um.svg",
    currencies: [
      {
        code: "GBP",
        name: "British pound",
        symbol: "£"
      }
    ]
  },
  {
    name: "Virgin Islands (British)",
    alpha2Code: "VG",
    alpha3Code: "VGB",
    callingCodes: [
      "1"
    ],
    capital: "Road Town",
    region: "Americas",
    latlng: [
      18.431383,
      -64.62305
    ],
    demonym: "Virgin Islander",
    timezones: [
      "UTC-04:00"
    ],
    flag: "https://flagcdn.com/vg.svg",
    currencies: [
      {
        code: "USD",
        name: "United States dollar",
        symbol: "$"
      }
    ]
  },
  {
    name: "Virgin Islands (U.S.)",
    alpha2Code: "VI",
    alpha3Code: "VIR",
    callingCodes: [
      "1 340"
    ],
    capital: "Charlotte Amalie",
    region: "Americas",
    latlng: [
      18.34,
      -64.93
    ],
    demonym: "Virgin Islander",
    timezones: [
      "UTC-04:00"
    ],
    flag: "https://flagcdn.com/vi.svg",
    currencies: [
      {
        code: "USD",
        name: "United States dollar",
        symbol: "$"
      }
    ]
  },
  {
    name: "Brunei Darussalam",
    alpha2Code: "BN",
    alpha3Code: "BRN",
    callingCodes: [
      "673"
    ],
    capital: "Bandar Seri Begawan",
    region: "Asia",
    latlng: [
      4.5,
      114.66666666
    ],
    demonym: "Bruneian",
    timezones: [
      "UTC+08:00"
    ],
    flag: "https://flagcdn.com/bn.svg",
    currencies: [
      {
        code: "BND",
        name: "Brunei dollar",
        symbol: "$"
      },
      {
        code: "SGD",
        name: "Singapore dollar",
        symbol: "$"
      }
    ]
  },
  {
    name: "Bulgaria",
    alpha2Code: "BG",
    alpha3Code: "BGR",
    callingCodes: [
      "359"
    ],
    capital: "Sofia",
    region: "Europe",
    latlng: [
      43,
      25
    ],
    demonym: "Bulgarian",
    timezones: [
      "UTC+02:00"
    ],
    flag: "https://flagcdn.com/bg.svg",
    currencies: [
      {
        code: "BGN",
        name: "Bulgarian lev",
        symbol: "лв"
      }
    ]
  },
  {
    name: "Burkina Faso",
    alpha2Code: "BF",
    alpha3Code: "BFA",
    callingCodes: [
      "226"
    ],
    capital: "Ouagadougou",
    region: "Africa",
    latlng: [
      13,
      -2
    ],
    demonym: "Burkinabe",
    timezones: [
      "UTC"
    ],
    flag: "https://flagcdn.com/bf.svg",
    currencies: [
      {
        code: "XOF",
        name: "West African CFA franc",
        symbol: "Fr"
      }
    ]
  },
  {
    name: "Burundi",
    alpha2Code: "BI",
    alpha3Code: "BDI",
    callingCodes: [
      "257"
    ],
    capital: "Gitega",
    region: "Africa",
    latlng: [
      -3.5,
      30
    ],
    demonym: "Burundian",
    timezones: [
      "UTC+02:00"
    ],
    flag: "https://flagcdn.com/bi.svg",
    currencies: [
      {
        code: "BIF",
        name: "Burundian franc",
        symbol: "Fr"
      }
    ]
  },
  {
    name: "Cambodia",
    alpha2Code: "KH",
    alpha3Code: "KHM",
    callingCodes: [
      "855"
    ],
    capital: "Phnom Penh",
    region: "Asia",
    latlng: [
      13,
      105
    ],
    demonym: "Cambodian",
    timezones: [
      "UTC+07:00"
    ],
    flag: "https://flagcdn.com/kh.svg",
    currencies: [
      {
        code: "KHR",
        name: "Cambodian riel",
        symbol: "៛"
      },
      {
        code: "USD",
        name: "United States dollar",
        symbol: "$"
      }
    ]
  },
  {
    name: "Cameroon",
    alpha2Code: "CM",
    alpha3Code: "CMR",
    callingCodes: [
      "237"
    ],
    capital: "Yaoundé",
    region: "Africa",
    latlng: [
      6,
      12
    ],
    demonym: "Cameroonian",
    timezones: [
      "UTC+01:00"
    ],
    flag: "https://flagcdn.com/cm.svg",
    currencies: [
      {
        code: "XAF",
        name: "Central African CFA franc",
        symbol: "Fr"
      }
    ]
  },
  {
    name: "Canada",
    alpha2Code: "CA",
    alpha3Code: "CAN",
    callingCodes: [
      "1"
    ],
    capital: "Ottawa",
    region: "Americas",
    latlng: [
      60,
      -95
    ],
    demonym: "Canadian",
    timezones: [
      "UTC-08:00",
      "UTC-07:00",
      "UTC-06:00",
      "UTC-05:00",
      "UTC-04:00",
      "UTC-03:30"
    ],
    flag: "https://flagcdn.com/ca.svg",
    currencies: [
      {
        code: "CAD",
        name: "Canadian dollar",
        symbol: "$"
      }
    ]
  },
  {
    name: "Cabo Verde",
    alpha2Code: "CV",
    alpha3Code: "CPV",
    callingCodes: [
      "238"
    ],
    capital: "Praia",
    region: "Africa",
    latlng: [
      16,
      -24
    ],
    demonym: "Cape Verdian",
    timezones: [
      "UTC-01:00"
    ],
    flag: "https://flagcdn.com/cv.svg",
    currencies: [
      {
        code: "CVE",
        name: "Cape Verdean escudo",
        symbol: "Esc"
      }
    ]
  },
  {
    name: "Cayman Islands",
    alpha2Code: "KY",
    alpha3Code: "CYM",
    callingCodes: [
      "1"
    ],
    capital: "George Town",
    region: "Americas",
    latlng: [
      19.5,
      -80.5
    ],
    demonym: "Caymanian",
    timezones: [
      "UTC-05:00"
    ],
    flag: "https://flagcdn.com/ky.svg",
    currencies: [
      {
        code: "KYD",
        name: "Cayman Islands dollar",
        symbol: "$"
      }
    ]
  },
  {
    name: "Central African Republic",
    alpha2Code: "CF",
    alpha3Code: "CAF",
    callingCodes: [
      "236"
    ],
    capital: "Bangui",
    region: "Africa",
    latlng: [
      7,
      21
    ],
    demonym: "Central African",
    timezones: [
      "UTC+01:00"
    ],
    flag: "https://flagcdn.com/cf.svg",
    currencies: [
      {
        code: "XAF",
        name: "Central African CFA franc",
        symbol: "Fr"
      }
    ]
  },
  {
    name: "Chad",
    alpha2Code: "TD",
    alpha3Code: "TCD",
    callingCodes: [
      "235"
    ],
    capital: "N'Djamena",
    region: "Africa",
    latlng: [
      15,
      19
    ],
    demonym: "Chadian",
    timezones: [
      "UTC+01:00"
    ],
    flag: "https://flagcdn.com/td.svg",
    currencies: [
      {
        code: "XAF",
        name: "Central African CFA franc",
        symbol: "Fr"
      }
    ]
  },
  {
    name: "Chile",
    alpha2Code: "CL",
    alpha3Code: "CHL",
    callingCodes: [
      "56"
    ],
    capital: "Santiago",
    region: "Americas",
    latlng: [
      -30,
      -71
    ],
    demonym: "Chilean",
    timezones: [
      "UTC-06:00",
      "UTC-04:00"
    ],
    flag: "https://flagcdn.com/cl.svg",
    currencies: [
      {
        code: "CLP",
        name: "Chilean peso",
        symbol: "$"
      }
    ]
  },
  {
    name: "China",
    alpha2Code: "CN",
    alpha3Code: "CHN",
    callingCodes: [
      "86"
    ],
    capital: "Beijing",
    region: "Asia",
    latlng: [
      35,
      105
    ],
    demonym: "Chinese",
    timezones: [
      "UTC+08:00"
    ],
    flag: "https://flagcdn.com/cn.svg",
    currencies: [
      {
        code: "CNY",
        name: "Chinese yuan",
        symbol: "¥"
      }
    ]
  },
  {
    name: "Christmas Island",
    alpha2Code: "CX",
    alpha3Code: "CXR",
    callingCodes: [
      "61"
    ],
    capital: "Flying Fish Cove",
    region: "Oceania",
    latlng: [
      -10.5,
      105.66666666
    ],
    demonym: "Christmas Island",
    timezones: [
      "UTC+07:00"
    ],
    flag: "https://flagcdn.com/cx.svg",
    currencies: [
      {
        code: "AUD",
        name: "Australian dollar",
        symbol: "$"
      }
    ]
  },
  {
    name: "Cocos (Keeling) Islands",
    alpha2Code: "CC",
    alpha3Code: "CCK",
    callingCodes: [
      "61"
    ],
    capital: "West Island",
    region: "Oceania",
    latlng: [
      -12.5,
      96.83333333
    ],
    demonym: "Cocos Islander",
    timezones: [
      "UTC+06:30"
    ],
    flag: "https://flagcdn.com/cc.svg",
    currencies: [
      {
        code: "AUD",
        name: "Australian dollar",
        symbol: "$"
      }
    ]
  },
  {
    name: "Colombia",
    alpha2Code: "CO",
    alpha3Code: "COL",
    callingCodes: [
      "57"
    ],
    capital: "Bogotá",
    region: "Americas",
    latlng: [
      4,
      -72
    ],
    demonym: "Colombian",
    timezones: [
      "UTC-05:00"
    ],
    flag: "https://flagcdn.com/co.svg",
    currencies: [
      {
        code: "COP",
        name: "Colombian peso",
        symbol: "$"
      }
    ]
  },
  {
    name: "Comoros",
    alpha2Code: "KM",
    alpha3Code: "COM",
    callingCodes: [
      "269"
    ],
    capital: "Moroni",
    region: "Africa",
    latlng: [
      -12.16666666,
      44.25
    ],
    demonym: "Comoran",
    timezones: [
      "UTC+03:00"
    ],
    flag: "https://flagcdn.com/km.svg",
    currencies: [
      {
        code: "KMF",
        name: "Comorian franc",
        symbol: "Fr"
      }
    ]
  },
  {
    name: "Congo",
    alpha2Code: "CG",
    alpha3Code: "COG",
    callingCodes: [
      "242"
    ],
    capital: "Brazzaville",
    region: "Africa",
    latlng: [
      -1,
      15
    ],
    demonym: "Congolese",
    timezones: [
      "UTC+01:00"
    ],
    flag: "https://flagcdn.com/cg.svg",
    currencies: [
      {
        code: "XAF",
        name: "Central African CFA franc",
        symbol: "Fr"
      }
    ]
  },
  {
    name: "Congo (Democratic Republic of the)",
    alpha2Code: "CD",
    alpha3Code: "COD",
    callingCodes: [
      "243"
    ],
    capital: "Kinshasa",
    region: "Africa",
    latlng: [
      0,
      25
    ],
    demonym: "Congolese",
    timezones: [
      "UTC+01:00",
      "UTC+02:00"
    ],
    flag: "https://flagcdn.com/cd.svg",
    currencies: [
      {
        code: "CDF",
        name: "Congolese franc",
        symbol: "Fr"
      }
    ]
  },
  {
    name: "Cook Islands",
    alpha2Code: "CK",
    alpha3Code: "COK",
    callingCodes: [
      "682"
    ],
    capital: "Avarua",
    region: "Oceania",
    latlng: [
      -21.23333333,
      -159.76666666
    ],
    demonym: "Cook Islander",
    timezones: [
      "UTC-10:00"
    ],
    flag: "https://flagcdn.com/ck.svg",
    currencies: [
      {
        code: "NZD",
        name: "New Zealand dollar",
        symbol: "$"
      },
      {
        code: "CKD",
        name: "Cook Islands dollar",
        symbol: "$"
      }
    ]
  },
  {
    name: "Costa Rica",
    alpha2Code: "CR",
    alpha3Code: "CRI",
    callingCodes: [
      "506"
    ],
    capital: "San José",
    region: "Americas",
    latlng: [
      10,
      -84
    ],
    demonym: "Costa Rican",
    timezones: [
      "UTC-06:00"
    ],
    flag: "https://flagcdn.com/cr.svg",
    currencies: [
      {
        code: "CRC",
        name: "Costa Rican colón",
        symbol: "₡"
      }
    ]
  },
  {
    name: "Croatia",
    alpha2Code: "HR",
    alpha3Code: "HRV",
    callingCodes: [
      "385"
    ],
    capital: "Zagreb",
    region: "Europe",
    latlng: [
      45.16666666,
      15.5
    ],
    demonym: "Croatian",
    timezones: [
      "UTC+01:00"
    ],
    flag: "https://flagcdn.com/hr.svg",
    currencies: [
      {
        code: "EUR",
        name: "Euro",
        symbol: "€"
      }
    ]
  },
  {
    name: "Cuba",
    alpha2Code: "CU",
    alpha3Code: "CUB",
    callingCodes: [
      "53"
    ],
    capital: "Havana",
    region: "Americas",
    latlng: [
      21.5,
      -80
    ],
    demonym: "Cuban",
    timezones: [
      "UTC-05:00"
    ],
    flag: "https://flagcdn.com/cu.svg",
    currencies: [
      {
        code: "CUC",
        name: "Cuban convertible peso",
        symbol: "$"
      },
      {
        code: "CUP",
        name: "Cuban peso",
        symbol: "$"
      }
    ]
  },
  {
    name: "Curaçao",
    alpha2Code: "CW",
    alpha3Code: "CUW",
    callingCodes: [
      "599"
    ],
    capital: "Willemstad",
    region: "Americas",
    latlng: [
      12.116667,
      -68.933333
    ],
    demonym: "Dutch",
    timezones: [
      "UTC-04:00"
    ],
    flag: "https://flagcdn.com/cw.svg",
    currencies: [
      {
        code: "ANG",
        name: "Netherlands Antillean guilder",
        symbol: "ƒ"
      }
    ]
  },
  {
    name: "Cyprus",
    alpha2Code: "CY",
    alpha3Code: "CYP",
    callingCodes: [
      "357"
    ],
    capital: "Nicosia",
    region: "Europe",
    latlng: [
      35,
      33
    ],
    demonym: "Cypriot",
    timezones: [
      "UTC+02:00"
    ],
    flag: "https://flagcdn.com/cy.svg",
    currencies: [
      {
        code: "EUR",
        name: "Euro",
        symbol: "€"
      }
    ]
  },
  {
    name: "Czech Republic",
    alpha2Code: "CZ",
    alpha3Code: "CZE",
    callingCodes: [
      "420"
    ],
    capital: "Prague",
    region: "Europe",
    latlng: [
      49.75,
      15.5
    ],
    demonym: "Czech",
    timezones: [
      "UTC+01:00"
    ],
    flag: "https://flagcdn.com/cz.svg",
    currencies: [
      {
        code: "CZK",
        name: "Czech koruna",
        symbol: "Kč"
      }
    ]
  },
  {
    name: "Denmark",
    alpha2Code: "DK",
    alpha3Code: "DNK",
    callingCodes: [
      "45"
    ],
    capital: "Copenhagen",
    region: "Europe",
    latlng: [
      56,
      10
    ],
    demonym: "Danish",
    timezones: [
      "UTC-04:00",
      "UTC-03:00",
      "UTC-01:00",
      "UTC",
      "UTC+01:00"
    ],
    flag: "https://flagcdn.com/dk.svg",
    currencies: [
      {
        code: "DKK",
        name: "Danish krone",
        symbol: "kr"
      }
    ]
  },
  {
    name: "Djibouti",
    alpha2Code: "DJ",
    alpha3Code: "DJI",
    callingCodes: [
      "253"
    ],
    capital: "Djibouti",
    region: "Africa",
    latlng: [
      11.5,
      43
    ],
    demonym: "Djibouti",
    timezones: [
      "UTC+03:00"
    ],
    flag: "https://flagcdn.com/dj.svg",
    currencies: [
      {
        code: "DJF",
        name: "Djiboutian franc",
        symbol: "Fr"
      }
    ]
  },
  {
    name: "Dominica",
    alpha2Code: "DM",
    alpha3Code: "DMA",
    callingCodes: [
      "1"
    ],
    capital: "Roseau",
    region: "Americas",
    latlng: [
      15.41666666,
      -61.33333333
    ],
    demonym: "Dominican",
    timezones: [
      "UTC-04:00"
    ],
    flag: "https://flagcdn.com/dm.svg",
    currencies: [
      {
        code: "XCD",
        name: "East Caribbean dollar",
        symbol: "$"
      }
    ]
  },
  {
    name: "Dominican Republic",
    alpha2Code: "DO",
    alpha3Code: "DOM",
    callingCodes: [
      "1"
    ],
    capital: "Santo Domingo",
    region: "Americas",
    latlng: [
      19,
      -70.66666666
    ],
    demonym: "Dominican",
    timezones: [
      "UTC-04:00"
    ],
    flag: "https://flagcdn.com/do.svg",
    currencies: [
      {
        code: "DOP",
        name: "Dominican peso",
        symbol: "$"
      }
    ]
  },
  {
    name: "Ecuador",
    alpha2Code: "EC",
    alpha3Code: "ECU",
    callingCodes: [
      "593"
    ],
    capital: "Quito",
    region: "Americas",
    latlng: [
      -2,
      -77.5
    ],
    demonym: "Ecuadorean",
    timezones: [
      "UTC-06:00",
      "UTC-05:00"
    ],
    flag: "https://flagcdn.com/ec.svg",
    currencies: [
      {
        code: "USD",
        name: "United States dollar",
        symbol: "$"
      }
    ]
  },
  {
    name: "Egypt",
    alpha2Code: "EG",
    alpha3Code: "EGY",
    callingCodes: [
      "20"
    ],
    capital: "Cairo",
    region: "Africa",
    latlng: [
      27,
      30
    ],
    demonym: "Egyptian",
    timezones: [
      "UTC+02:00"
    ],
    flag: "https://flagcdn.com/eg.svg",
    currencies: [
      {
        code: "EGP",
        name: "Egyptian pound",
        symbol: "£"
      }
    ]
  },
  {
    name: "El Salvador",
    alpha2Code: "SV",
    alpha3Code: "SLV",
    callingCodes: [
      "503"
    ],
    capital: "San Salvador",
    region: "Americas",
    latlng: [
      13.83333333,
      -88.91666666
    ],
    demonym: "Salvadoran",
    timezones: [
      "UTC-06:00"
    ],
    flag: "https://flagcdn.com/sv.svg",
    currencies: [
      {
        code: "USD",
        name: "United States dollar",
        symbol: "$"
      }
    ]
  },
  {
    name: "Equatorial Guinea",
    alpha2Code: "GQ",
    alpha3Code: "GNQ",
    callingCodes: [
      "240"
    ],
    capital: "Malabo",
    region: "Africa",
    latlng: [
      2,
      10
    ],
    demonym: "Equatorial Guinean",
    timezones: [
      "UTC+01:00"
    ],
    flag: "https://flagcdn.com/gq.svg",
    currencies: [
      {
        code: "XAF",
        name: "Central African CFA franc",
        symbol: "Fr"
      }
    ]
  },
  {
    name: "Eritrea",
    alpha2Code: "ER",
    alpha3Code: "ERI",
    callingCodes: [
      "291"
    ],
    capital: "Asmara",
    region: "Africa",
    latlng: [
      15,
      39
    ],
    demonym: "Eritrean",
    timezones: [
      "UTC+03:00"
    ],
    flag: "https://flagcdn.com/er.svg",
    currencies: [
      {
        code: "ERN",
        name: "Eritrean nakfa",
        symbol: "Nfk"
      }
    ]
  },
  {
    name: "Estonia",
    alpha2Code: "EE",
    alpha3Code: "EST",
    callingCodes: [
      "372"
    ],
    capital: "Tallinn",
    region: "Europe",
    latlng: [
      59,
      26
    ],
    demonym: "Estonian",
    timezones: [
      "UTC+02:00"
    ],
    flag: "https://flagcdn.com/ee.svg",
    currencies: [
      {
        code: "EUR",
        name: "Euro",
        symbol: "€"
      }
    ]
  },
  {
    name: "Ethiopia",
    alpha2Code: "ET",
    alpha3Code: "ETH",
    callingCodes: [
      "251"
    ],
    capital: "Addis Ababa",
    region: "Africa",
    latlng: [
      8,
      38
    ],
    demonym: "Ethiopian",
    timezones: [
      "UTC+03:00"
    ],
    flag: "https://flagcdn.com/et.svg",
    currencies: [
      {
        code: "ETB",
        name: "Ethiopian birr",
        symbol: "Br"
      }
    ]
  },
  {
    name: "Falkland Islands (Malvinas)",
    alpha2Code: "FK",
    alpha3Code: "FLK",
    callingCodes: [
      "500"
    ],
    capital: "Stanley",
    region: "Americas",
    latlng: [
      -51.75,
      -59
    ],
    demonym: "Falkland Islander",
    timezones: [
      "UTC-04:00"
    ],
    flag: "https://flagcdn.com/fk.svg",
    currencies: [
      {
        code: "FKP",
        name: "Falkland Islands pound",
        symbol: "£"
      }
    ]
  },
  {
    name: "Faroe Islands",
    alpha2Code: "FO",
    alpha3Code: "FRO",
    callingCodes: [
      "298"
    ],
    capital: "Tórshavn",
    region: "Europe",
    latlng: [
      62,
      -7
    ],
    demonym: "Faroese",
    timezones: [
      "UTC+00:00"
    ],
    flag: "https://flagcdn.com/fo.svg",
    currencies: [
      {
        code: "DKK",
        name: "Danish krone",
        symbol: "kr"
      },
      {
        code: "FOK",
        name: "Faroese króna",
        symbol: "kr"
      }
    ]
  },
  {
    name: "Fiji",
    alpha2Code: "FJ",
    alpha3Code: "FJI",
    callingCodes: [
      "679"
    ],
    capital: "Suva",
    region: "Oceania",
    latlng: [
      -18,
      175
    ],
    demonym: "Fijian",
    timezones: [
      "UTC+12:00"
    ],
    flag: "https://flagcdn.com/fj.svg",
    currencies: [
      {
        code: "FJD",
        name: "Fijian dollar",
        symbol: "$"
      }
    ]
  },
  {
    name: "Finland",
    alpha2Code: "FI",
    alpha3Code: "FIN",
    callingCodes: [
      "358"
    ],
    capital: "Helsinki",
    region: "Europe",
    latlng: [
      64,
      26
    ],
    demonym: "Finnish",
    timezones: [
      "UTC+02:00"
    ],
    flag: "https://flagcdn.com/fi.svg",
    currencies: [
      {
        code: "EUR",
        name: "Euro",
        symbol: "€"
      }
    ]
  },
  {
    name: "France",
    alpha2Code: "FR",
    alpha3Code: "FRA",
    callingCodes: [
      "33"
    ],
    capital: "Paris",
    region: "Europe",
    latlng: [
      46,
      2
    ],
    demonym: "French",
    timezones: [
      "UTC-10:00",
      "UTC-09:30",
      "UTC-09:00",
      "UTC-08:00",
      "UTC-04:00",
      "UTC-03:00",
      "UTC+01:00",
      "UTC+02:00",
      "UTC+03:00",
      "UTC+04:00",
      "UTC+05:00",
      "UTC+10:00",
      "UTC+11:00",
      "UTC+12:00"
    ],
    flag: "https://flagcdn.com/fr.svg",
    currencies: [
      {
        code: "EUR",
        name: "Euro",
        symbol: "€"
      }
    ]
  },
  {
    name: "French Guiana",
    alpha2Code: "GF",
    alpha3Code: "GUF",
    callingCodes: [
      "594"
    ],
    capital: "Cayenne",
    region: "Americas",
    latlng: [
      4,
      -53
    ],
    demonym: "French Guianan",
    timezones: [
      "UTC-03:00"
    ],
    flag: "https://flagcdn.com/gf.svg",
    currencies: [
      {
        code: "EUR",
        name: "Euro",
        symbol: "€"
      }
    ]
  },
  {
    name: "French Polynesia",
    alpha2Code: "PF",
    alpha3Code: "PYF",
    callingCodes: [
      "689"
    ],
    capital: "Papeetē",
    region: "Oceania",
    latlng: [
      -15,
      -140
    ],
    demonym: "French Polynesian",
    timezones: [
      "UTC-10:00",
      "UTC-09:30",
      "UTC-09:00"
    ],
    flag: "https://flagcdn.com/pf.svg",
    currencies: [
      {
        code: "XPF",
        name: "CFP franc",
        symbol: "Fr"
      }
    ]
  },
  {
    name: "French Southern Territories",
    alpha2Code: "TF",
    alpha3Code: "ATF",
    callingCodes: [
      "262"
    ],
    capital: "Port-aux-Français",
    region: "Africa",
    latlng: [
      -49.25,
      69.167
    ],
    demonym: "French",
    timezones: [
      "UTC+05:00"
    ],
    flag: "https://flagcdn.com/tf.svg",
    currencies: [
      {
        code: "EUR",
        name: "Euro",
        symbol: "€"
      }
    ]
  },
  {
    name: "Gabon",
    alpha2Code: "GA",
    alpha3Code: "GAB",
    callingCodes: [
      "241"
    ],
    capital: "Libreville",
    region: "Africa",
    latlng: [
      -1,
      11.75
    ],
    demonym: "Gabonese",
    timezones: [
      "UTC+01:00"
    ],
    flag: "https://flagcdn.com/ga.svg",
    currencies: [
      {
        code: "XAF",
        name: "Central African CFA franc",
        symbol: "Fr"
      }
    ]
  },
  {
    name: "Gambia",
    alpha2Code: "GM",
    alpha3Code: "GMB",
    callingCodes: [
      "220"
    ],
    capital: "Banjul",
    region: "Africa",
    latlng: [
      13.46666666,
      -16.56666666
    ],
    demonym: "Gambian",
    timezones: [
      "UTC+00:00"
    ],
    flag: "https://flagcdn.com/gm.svg",
    currencies: [
      {
        code: "GMD",
        name: "Gambian dalasi",
        symbol: "D"
      }
    ]
  },
  {
    name: "Georgia",
    alpha2Code: "GE",
    alpha3Code: "GEO",
    callingCodes: [
      "995"
    ],
    capital: "Tbilisi",
    region: "Asia",
    latlng: [
      42,
      43.5
    ],
    demonym: "Georgian",
    timezones: [
      "UTC-04:00"
    ],
    flag: "https://flagcdn.com/ge.svg",
    currencies: [
      {
        code: "GEL",
        name: "Georgian Lari",
        symbol: "ლ"
      }
    ]
  },
  {
    name: "Germany",
    alpha2Code: "DE",
    alpha3Code: "DEU",
    callingCodes: [
      "49"
    ],
    capital: "Berlin",
    region: "Europe",
    latlng: [
      51,
      9
    ],
    demonym: "German",
    timezones: [
      "UTC+01:00"
    ],
    flag: "https://flagcdn.com/de.svg",
    currencies: [
      {
        code: "EUR",
        name: "Euro",
        symbol: "€"
      }
    ]
  },
  {
    name: "Ghana",
    alpha2Code: "GH",
    alpha3Code: "GHA",
    callingCodes: [
      "233"
    ],
    capital: "Accra",
    region: "Africa",
    latlng: [
      8,
      -2
    ],
    demonym: "Ghanaian",
    timezones: [
      "UTC"
    ],
    flag: "https://flagcdn.com/gh.svg",
    currencies: [
      {
        code: "GHS",
        name: "Ghanaian cedi",
        symbol: "₵"
      }
    ]
  },
  {
    name: "Gibraltar",
    alpha2Code: "GI",
    alpha3Code: "GIB",
    callingCodes: [
      "350"
    ],
    capital: "Gibraltar",
    region: "Europe",
    latlng: [
      36.13333333,
      -5.35
    ],
    demonym: "Gibraltar",
    timezones: [
      "UTC+01:00"
    ],
    flag: "https://flagcdn.com/gi.svg",
    currencies: [
      {
        code: "GIP",
        name: "Gibraltar pound",
        symbol: "£"
      }
    ]
  },
  {
    name: "Greece",
    alpha2Code: "GR",
    alpha3Code: "GRC",
    callingCodes: [
      "30"
    ],
    capital: "Athens",
    region: "Europe",
    latlng: [
      39,
      22
    ],
    demonym: "Greek",
    timezones: [
      "UTC+02:00"
    ],
    flag: "https://flagcdn.com/gr.svg",
    currencies: [
      {
        code: "EUR",
        name: "Euro",
        symbol: "€"
      }
    ]
  },
  {
    name: "Greenland",
    alpha2Code: "GL",
    alpha3Code: "GRL",
    callingCodes: [
      "299"
    ],
    capital: "Nuuk",
    region: "Americas",
    latlng: [
      72,
      -40
    ],
    demonym: "Greenlandic",
    timezones: [
      "UTC-04:00",
      "UTC-03:00",
      "UTC-01:00",
      "UTC+00:00"
    ],
    flag: "https://flagcdn.com/gl.svg",
    currencies: [
      {
        code: "DKK",
        name: "Danish krone",
        symbol: "kr"
      }
    ]
  },
  {
    name: "Grenada",
    alpha2Code: "GD",
    alpha3Code: "GRD",
    callingCodes: [
      "1"
    ],
    capital: "St. George's",
    region: "Americas",
    latlng: [
      12.11666666,
      -61.66666666
    ],
    demonym: "Grenadian",
    timezones: [
      "UTC-04:00"
    ],
    flag: "https://flagcdn.com/gd.svg",
    currencies: [
      {
        code: "XCD",
        name: "East Caribbean dollar",
        symbol: "$"
      }
    ]
  },
  {
    name: "Guadeloupe",
    alpha2Code: "GP",
    alpha3Code: "GLP",
    callingCodes: [
      "590"
    ],
    capital: "Basse-Terre",
    region: "Americas",
    latlng: [
      16.25,
      -61.583333
    ],
    demonym: "Guadeloupian",
    timezones: [
      "UTC-04:00"
    ],
    flag: "https://flagcdn.com/gp.svg",
    currencies: [
      {
        code: "EUR",
        name: "Euro",
        symbol: "€"
      }
    ]
  },
  {
    name: "Guam",
    alpha2Code: "GU",
    alpha3Code: "GUM",
    callingCodes: [
      "1"
    ],
    capital: "Hagåtña",
    region: "Oceania",
    latlng: [
      13.46666666,
      144.78333333
    ],
    demonym: "Guamanian",
    timezones: [
      "UTC+10:00"
    ],
    flag: "https://flagcdn.com/gu.svg",
    currencies: [
      {
        code: "USD",
        name: "United States dollar",
        symbol: "$"
      }
    ]
  },
  {
    name: "Guatemala",
    alpha2Code: "GT",
    alpha3Code: "GTM",
    callingCodes: [
      "502"
    ],
    capital: "Guatemala City",
    region: "Americas",
    latlng: [
      15.5,
      -90.25
    ],
    demonym: "Guatemalan",
    timezones: [
      "UTC-06:00"
    ],
    flag: "https://flagcdn.com/gt.svg",
    currencies: [
      {
        code: "GTQ",
        name: "Guatemalan quetzal",
        symbol: "Q"
      }
    ]
  },
  {
    name: "Guernsey",
    alpha2Code: "GG",
    alpha3Code: "GGY",
    callingCodes: [
      "44"
    ],
    capital: "St. Peter Port",
    region: "Europe",
    latlng: [
      49.46666666,
      -2.58333333
    ],
    demonym: "Channel Islander",
    timezones: [
      "UTC+00:00"
    ],
    flag: "https://flagcdn.com/gg.svg",
    currencies: [
      {
        code: "GBP",
        name: "British pound",
        symbol: "£"
      },
      {
        code: "GGP",
        name: "Guernsey pound",
        symbol: "£"
      }
    ]
  },
  {
    name: "Guinea",
    alpha2Code: "GN",
    alpha3Code: "GIN",
    callingCodes: [
      "224"
    ],
    capital: "Conakry",
    region: "Africa",
    latlng: [
      11,
      -10
    ],
    demonym: "Guinean",
    timezones: [
      "UTC"
    ],
    flag: "https://flagcdn.com/gn.svg",
    currencies: [
      {
        code: "GNF",
        name: "Guinean franc",
        symbol: "Fr"
      }
    ]
  },
  {
    name: "Guinea-Bissau",
    alpha2Code: "GW",
    alpha3Code: "GNB",
    callingCodes: [
      "245"
    ],
    capital: "Bissau",
    region: "Africa",
    latlng: [
      12,
      -15
    ],
    demonym: "Guinea-Bissauan",
    timezones: [
      "UTC"
    ],
    flag: "https://flagcdn.com/gw.svg",
    currencies: [
      {
        code: "XOF",
        name: "West African CFA franc",
        symbol: "Fr"
      }
    ]
  },
  {
    name: "Guyana",
    alpha2Code: "GY",
    alpha3Code: "GUY",
    callingCodes: [
      "592"
    ],
    capital: "Georgetown",
    region: "Americas",
    latlng: [
      5,
      -59
    ],
    demonym: "Guyanese",
    timezones: [
      "UTC-04:00"
    ],
    flag: "https://flagcdn.com/gy.svg",
    currencies: [
      {
        code: "GYD",
        name: "Guyanese dollar",
        symbol: "$"
      }
    ]
  },
  {
    name: "Haiti",
    alpha2Code: "HT",
    alpha3Code: "HTI",
    callingCodes: [
      "509"
    ],
    capital: "Port-au-Prince",
    region: "Americas",
    latlng: [
      19,
      -72.41666666
    ],
    demonym: "Haitian",
    timezones: [
      "UTC-05:00"
    ],
    flag: "https://flagcdn.com/ht.svg",
    currencies: [
      {
        code: "HTG",
        name: "Haitian gourde",
        symbol: "G"
      }
    ]
  },
  {
    name: "Heard Island and McDonald Islands",
    alpha2Code: "HM",
    alpha3Code: "HMD",
    callingCodes: [
      "672"
    ],
    capital: null,
    region: "Antarctic",
    latlng: [
      -53.1,
      72.51666666
    ],
    demonym: "Heard and McDonald Islander",
    timezones: [
      "UTC+05:00"
    ],
    flag: "https://flagcdn.com/hm.svg",
    currencies: [
      {
        code: "AUD",
        name: "Australian dollar",
        symbol: "$"
      }
    ]
  },
  {
    name: "Vatican City",
    alpha2Code: "VA",
    alpha3Code: "VAT",
    callingCodes: [
      "379"
    ],
    capital: "Vatican City",
    region: "Europe",
    latlng: [
      41.9,
      12.45
    ],
    demonym: "Vatican",
    timezones: [
      "UTC+01:00"
    ],
    flag: "https://flagcdn.com/va.svg",
    currencies: [
      {
        code: "EUR",
        name: "Euro",
        symbol: "€"
      }
    ]
  },
  {
    name: "Honduras",
    alpha2Code: "HN",
    alpha3Code: "HND",
    callingCodes: [
      "504"
    ],
    capital: "Tegucigalpa",
    region: "Americas",
    latlng: [
      15,
      -86.5
    ],
    demonym: "Honduran",
    timezones: [
      "UTC-06:00"
    ],
    flag: "https://flagcdn.com/hn.svg",
    currencies: [
      {
        code: "HNL",
        name: "Honduran lempira",
        symbol: "L"
      }
    ]
  },
  {
    name: "Hungary",
    alpha2Code: "HU",
    alpha3Code: "HUN",
    callingCodes: [
      "36"
    ],
    capital: "Budapest",
    region: "Europe",
    latlng: [
      47,
      20
    ],
    demonym: "Hungarian",
    timezones: [
      "UTC+01:00"
    ],
    flag: "https://flagcdn.com/hu.svg",
    currencies: [
      {
        code: "HUF",
        name: "Hungarian forint",
        symbol: "Ft"
      }
    ]
  },
  {
    name: "Hong Kong",
    alpha2Code: "HK",
    alpha3Code: "HKG",
    callingCodes: [
      "852"
    ],
    capital: "City of Victoria",
    region: "Asia",
    latlng: [
      22.25,
      114.16666666
    ],
    demonym: "Chinese",
    timezones: [
      "UTC+08:00"
    ],
    flag: "https://flagcdn.com/hk.svg",
    currencies: [
      {
        code: "HKD",
        name: "Hong Kong dollar",
        symbol: "$"
      }
    ]
  },
  {
    name: "Iceland",
    alpha2Code: "IS",
    alpha3Code: "ISL",
    callingCodes: [
      "354"
    ],
    capital: "Reykjavík",
    region: "Europe",
    latlng: [
      65,
      -18
    ],
    demonym: "Icelander",
    timezones: [
      "UTC"
    ],
    flag: "https://flagcdn.com/is.svg",
    currencies: [
      {
        code: "ISK",
        name: "Icelandic króna",
        symbol: "kr"
      }
    ]
  },
  {
    name: "India",
    alpha2Code: "IN",
    alpha3Code: "IND",
    callingCodes: [
      "91"
    ],
    capital: "New Delhi",
    region: "Asia",
    latlng: [
      20,
      77
    ],
    demonym: "Indian",
    timezones: [
      "UTC+05:30"
    ],
    flag: "https://flagcdn.com/in.svg",
    currencies: [
      {
        code: "INR",
        name: "Indian rupee",
        symbol: "₹"
      }
    ]
  },
  {
    name: "Indonesia",
    alpha2Code: "ID",
    alpha3Code: "IDN",
    callingCodes: [
      "62"
    ],
    capital: "Jakarta",
    region: "Asia",
    latlng: [
      -5,
      120
    ],
    demonym: "Indonesian",
    timezones: [
      "UTC+07:00",
      "UTC+08:00",
      "UTC+09:00"
    ],
    flag: "https://flagcdn.com/id.svg",
    currencies: [
      {
        code: "IDR",
        name: "Indonesian rupiah",
        symbol: "Rp"
      }
    ]
  },
  {
    name: "Ivory Coast",
    alpha2Code: "CI",
    alpha3Code: "CIV",
    callingCodes: [
      "225"
    ],
    capital: "Yamoussoukro",
    region: "Africa",
    latlng: [
      8,
      -5
    ],
    demonym: "Ivorian",
    timezones: [
      "UTC"
    ],
    flag: "https://flagcdn.com/ci.svg",
    currencies: [
      {
        code: "XOF",
        name: "West African CFA franc",
        symbol: "Fr"
      }
    ]
  },
  {
    name: "Iran (Islamic Republic of)",
    alpha2Code: "IR",
    alpha3Code: "IRN",
    callingCodes: [
      "98"
    ],
    capital: "Tehran",
    region: "Asia",
    latlng: [
      32,
      53
    ],
    demonym: "Iranian",
    timezones: [
      "UTC+03:30"
    ],
    flag: "https://flagcdn.com/ir.svg",
    currencies: [
      {
        code: "IRR",
        name: "Iranian rial",
        symbol: "﷼"
      }
    ]
  },
  {
    name: "Iraq",
    alpha2Code: "IQ",
    alpha3Code: "IRQ",
    callingCodes: [
      "964"
    ],
    capital: "Baghdad",
    region: "Asia",
    latlng: [
      33,
      44
    ],
    demonym: "Iraqi",
    timezones: [
      "UTC+03:00"
    ],
    flag: "https://flagcdn.com/iq.svg",
    currencies: [
      {
        code: "IQD",
        name: "Iraqi dinar",
        symbol: "ع.د"
      }
    ]
  },
  {
    name: "Ireland",
    alpha2Code: "IE",
    alpha3Code: "IRL",
    callingCodes: [
      "353"
    ],
    capital: "Dublin",
    region: "Europe",
    latlng: [
      53,
      -8
    ],
    demonym: "Irish",
    timezones: [
      "UTC"
    ],
    flag: "https://flagcdn.com/ie.svg",
    currencies: [
      {
        code: "EUR",
        name: "Euro",
        symbol: "€"
      }
    ]
  },
  {
    name: "Isle of Man",
    alpha2Code: "IM",
    alpha3Code: "IMN",
    callingCodes: [
      "44"
    ],
    capital: "Douglas",
    region: "Europe",
    latlng: [
      54.25,
      -4.5
    ],
    demonym: "Manx",
    timezones: [
      "UTC+00:00"
    ],
    flag: "https://flagcdn.com/im.svg",
    currencies: [
      {
        code: "GBP",
        name: "British pound",
        symbol: "£"
      },
      {
        code: "IMP[G]",
        name: "Manx pound",
        symbol: "£"
      }
    ]
  },
  {
    name: "Israel",
    alpha2Code: "IL",
    alpha3Code: "ISR",
    callingCodes: [
      "972"
    ],
    capital: "Jerusalem",
    region: "Asia",
    latlng: [
      31.5,
      34.75
    ],
    demonym: "Israeli",
    timezones: [
      "UTC+02:00"
    ],
    flag: "https://flagcdn.com/il.svg",
    currencies: [
      {
        code: "ILS",
        name: "Israeli new shekel",
        symbol: "₪"
      }
    ]
  },
  {
    name: "Italy",
    alpha2Code: "IT",
    alpha3Code: "ITA",
    callingCodes: [
      "39"
    ],
    capital: "Rome",
    region: "Europe",
    latlng: [
      42.83333333,
      12.83333333
    ],
    demonym: "Italian",
    timezones: [
      "UTC+01:00"
    ],
    flag: "https://flagcdn.com/it.svg",
    currencies: [
      {
        code: "EUR",
        name: "Euro",
        symbol: "€"
      }
    ]
  },
  {
    name: "Jamaica",
    alpha2Code: "JM",
    alpha3Code: "JAM",
    callingCodes: [
      "1"
    ],
    capital: "Kingston",
    region: "Americas",
    latlng: [
      18.25,
      -77.5
    ],
    demonym: "Jamaican",
    timezones: [
      "UTC-05:00"
    ],
    flag: "https://flagcdn.com/jm.svg",
    currencies: [
      {
        code: "JMD",
        name: "Jamaican dollar",
        symbol: "$"
      }
    ]
  },
  {
    name: "Japan",
    alpha2Code: "JP",
    alpha3Code: "JPN",
    callingCodes: [
      "81"
    ],
    capital: "Tokyo",
    region: "Asia",
    latlng: [
      36,
      138
    ],
    demonym: "Japanese",
    timezones: [
      "UTC+09:00"
    ],
    flag: "https://flagcdn.com/jp.svg",
    currencies: [
      {
        code: "JPY",
        name: "Japanese yen",
        symbol: "¥"
      }
    ]
  },
  {
    name: "Jersey",
    alpha2Code: "JE",
    alpha3Code: "JEY",
    callingCodes: [
      "44"
    ],
    capital: "Saint Helier",
    region: "Europe",
    latlng: [
      49.25,
      -2.16666666
    ],
    demonym: "Channel Islander",
    timezones: [
      "UTC+01:00"
    ],
    flag: "https://flagcdn.com/je.svg",
    currencies: [
      {
        code: "GBP",
        name: "British pound",
        symbol: "£"
      },
      {
        code: "JEP[G]",
        name: "Jersey pound",
        symbol: "£"
      }
    ]
  },
  {
    name: "Jordan",
    alpha2Code: "JO",
    alpha3Code: "JOR",
    callingCodes: [
      "962"
    ],
    capital: "Amman",
    region: "Asia",
    latlng: [
      31,
      36
    ],
    demonym: "Jordanian",
    timezones: [
      "UTC+03:00"
    ],
    flag: "https://flagcdn.com/jo.svg",
    currencies: [
      {
        code: "JOD",
        name: "Jordanian dinar",
        symbol: "د.ا"
      }
    ]
  },
  {
    name: "Kazakhstan",
    alpha2Code: "KZ",
    alpha3Code: "KAZ",
    callingCodes: [
      "76",
      "77"
    ],
    capital: "Nur-Sultan",
    region: "Asia",
    latlng: [
      48,
      68
    ],
    demonym: "Kazakhstani",
    timezones: [
      "UTC+05:00",
      "UTC+06:00"
    ],
    flag: "https://flagcdn.com/kz.svg",
    currencies: [
      {
        code: "KZT",
        name: "Kazakhstani tenge",
        symbol: "₸"
      }
    ]
  },
  {
    name: "Kenya",
    alpha2Code: "KE",
    alpha3Code: "KEN",
    callingCodes: [
      "254"
    ],
    capital: "Nairobi",
    region: "Africa",
    latlng: [
      1,
      38
    ],
    demonym: "Kenyan",
    timezones: [
      "UTC+03:00"
    ],
    flag: "https://flagcdn.com/ke.svg",
    currencies: [
      {
        code: "KES",
        name: "Kenyan shilling",
        symbol: "Sh"
      }
    ]
  },
  {
    name: "Kiribati",
    alpha2Code: "KI",
    alpha3Code: "KIR",
    callingCodes: [
      "686"
    ],
    capital: "South Tarawa",
    region: "Oceania",
    latlng: [
      1.41666666,
      173
    ],
    demonym: "I-Kiribati",
    timezones: [
      "UTC+12:00",
      "UTC+13:00",
      "UTC+14:00"
    ],
    flag: "https://flagcdn.com/ki.svg",
    currencies: [
      {
        code: "AUD",
        name: "Australian dollar",
        symbol: "$"
      },
      {
        code: "KID",
        name: "Kiribati dollar",
        symbol: "$"
      }
    ]
  },
  {
    name: "Kuwait",
    alpha2Code: "KW",
    alpha3Code: "KWT",
    callingCodes: [
      "965"
    ],
    capital: "Kuwait City",
    region: "Asia",
    latlng: [
      29.5,
      45.75
    ],
    demonym: "Kuwaiti",
    timezones: [
      "UTC+03:00"
    ],
    flag: "https://flagcdn.com/kw.svg",
    currencies: [
      {
        code: "KWD",
        name: "Kuwaiti dinar",
        symbol: "د.ك"
      }
    ]
  },
  {
    name: "Kyrgyzstan",
    alpha2Code: "KG",
    alpha3Code: "KGZ",
    callingCodes: [
      "996"
    ],
    capital: "Bishkek",
    region: "Asia",
    latlng: [
      41,
      75
    ],
    demonym: "Kirghiz",
    timezones: [
      "UTC+06:00"
    ],
    flag: "https://flagcdn.com/kg.svg",
    currencies: [
      {
        code: "KGS",
        name: "Kyrgyzstani som",
        symbol: "с"
      }
    ]
  },
  {
    name: "Lao People's Democratic Republic",
    alpha2Code: "LA",
    alpha3Code: "LAO",
    callingCodes: [
      "856"
    ],
    capital: "Vientiane",
    region: "Asia",
    latlng: [
      18,
      105
    ],
    demonym: "Laotian",
    timezones: [
      "UTC+07:00"
    ],
    flag: "https://flagcdn.com/la.svg",
    currencies: [
      {
        code: "LAK",
        name: "Lao kip",
        symbol: "₭"
      }
    ]
  },
  {
    name: "Latvia",
    alpha2Code: "LV",
    alpha3Code: "LVA",
    callingCodes: [
      "371"
    ],
    capital: "Riga",
    region: "Europe",
    latlng: [
      57,
      25
    ],
    demonym: "Latvian",
    timezones: [
      "UTC+02:00"
    ],
    flag: "https://flagcdn.com/lv.svg",
    currencies: [
      {
        code: "EUR",
        name: "Euro",
        symbol: "€"
      }
    ]
  },
  {
    name: "Lebanon",
    alpha2Code: "LB",
    alpha3Code: "LBN",
    callingCodes: [
      "961"
    ],
    capital: "Beirut",
    region: "Asia",
    latlng: [
      33.83333333,
      35.83333333
    ],
    demonym: "Lebanese",
    timezones: [
      "UTC+02:00"
    ],
    flag: "https://flagcdn.com/lb.svg",
    currencies: [
      {
        code: "LBP",
        name: "Lebanese pound",
        symbol: "ل.ل"
      }
    ]
  },
  {
    name: "Lesotho",
    alpha2Code: "LS",
    alpha3Code: "LSO",
    callingCodes: [
      "266"
    ],
    capital: "Maseru",
    region: "Africa",
    latlng: [
      -29.5,
      28.5
    ],
    demonym: "Mosotho",
    timezones: [
      "UTC+02:00"
    ],
    flag: "https://flagcdn.com/ls.svg",
    currencies: [
      {
        code: "LSL",
        name: "Lesotho loti",
        symbol: "L"
      },
      {
        code: "ZAR",
        name: "South African rand",
        symbol: "R"
      }
    ]
  },
  {
    name: "Liberia",
    alpha2Code: "LR",
    alpha3Code: "LBR",
    callingCodes: [
      "231"
    ],
    capital: "Monrovia",
    region: "Africa",
    latlng: [
      6.5,
      -9.5
    ],
    demonym: "Liberian",
    timezones: [
      "UTC"
    ],
    flag: "https://flagcdn.com/lr.svg",
    currencies: [
      {
        code: "LRD",
        name: "Liberian dollar",
        symbol: "$"
      }
    ]
  },
  {
    name: "Libya",
    alpha2Code: "LY",
    alpha3Code: "LBY",
    callingCodes: [
      "218"
    ],
    capital: "Tripoli",
    region: "Africa",
    latlng: [
      25,
      17
    ],
    demonym: "Libyan",
    timezones: [
      "UTC+01:00"
    ],
    flag: "https://flagcdn.com/ly.svg",
    currencies: [
      {
        code: "LYD",
        name: "Libyan dinar",
        symbol: "ل.د"
      }
    ]
  },
  {
    name: "Liechtenstein",
    alpha2Code: "LI",
    alpha3Code: "LIE",
    callingCodes: [
      "423"
    ],
    capital: "Vaduz",
    region: "Europe",
    latlng: [
      47.26666666,
      9.53333333
    ],
    demonym: "Liechtensteiner",
    timezones: [
      "UTC+01:00"
    ],
    flag: "https://flagcdn.com/li.svg",
    currencies: [
      {
        code: "CHF",
        name: "Swiss franc",
        symbol: "Fr"
      }
    ]
  },
  {
    name: "Lithuania",
    alpha2Code: "LT",
    alpha3Code: "LTU",
    callingCodes: [
      "370"
    ],
    capital: "Vilnius",
    region: "Europe",
    latlng: [
      56,
      24
    ],
    demonym: "Lithuanian",
    timezones: [
      "UTC+02:00"
    ],
    flag: "https://flagcdn.com/lt.svg",
    currencies: [
      {
        code: "EUR",
        name: "Euro",
        symbol: "€"
      }
    ]
  },
  {
    name: "Luxembourg",
    alpha2Code: "LU",
    alpha3Code: "LUX",
    callingCodes: [
      "352"
    ],
    capital: "Luxembourg",
    region: "Europe",
    latlng: [
      49.75,
      6.16666666
    ],
    demonym: "Luxembourger",
    timezones: [
      "UTC+01:00"
    ],
    flag: "https://flagcdn.com/lu.svg",
    currencies: [
      {
        code: "EUR",
        name: "Euro",
        symbol: "€"
      }
    ]
  },
  {
    name: "Macao",
    alpha2Code: "MO",
    alpha3Code: "MAC",
    callingCodes: [
      "853"
    ],
    capital: null,
    region: "Asia",
    latlng: [
      22.16666666,
      113.55
    ],
    demonym: "Chinese",
    timezones: [
      "UTC+08:00"
    ],
    flag: "https://flagcdn.com/mo.svg",
    currencies: [
      {
        code: "MOP",
        name: "Macanese pataca",
        symbol: "P"
      }
    ]
  },
  {
    name: "North Macedonia",
    alpha2Code: "MK",
    alpha3Code: "MKD",
    callingCodes: [
      "389"
    ],
    capital: "Skopje",
    region: "Europe",
    latlng: [
      41.83333333,
      22
    ],
    demonym: "Macedonian",
    timezones: [
      "UTC+01:00"
    ],
    flag: "https://flagcdn.com/mk.svg",
    currencies: [
      {
        code: "MKD",
        name: "Macedonian denar",
        symbol: "ден"
      }
    ]
  },
  {
    name: "Madagascar",
    alpha2Code: "MG",
    alpha3Code: "MDG",
    callingCodes: [
      "261"
    ],
    capital: "Antananarivo",
    region: "Africa",
    latlng: [
      -20,
      47
    ],
    demonym: "Malagasy",
    timezones: [
      "UTC+03:00"
    ],
    flag: "https://flagcdn.com/mg.svg",
    currencies: [
      {
        code: "MGA",
        name: "Malagasy ariary",
        symbol: "Ar"
      }
    ]
  },
  {
    name: "Malawi",
    alpha2Code: "MW",
    alpha3Code: "MWI",
    callingCodes: [
      "265"
    ],
    capital: "Lilongwe",
    region: "Africa",
    latlng: [
      -13.5,
      34
    ],
    demonym: "Malawian",
    timezones: [
      "UTC+02:00"
    ],
    flag: "https://flagcdn.com/mw.svg",
    currencies: [
      {
        code: "MWK",
        name: "Malawian kwacha",
        symbol: "MK"
      }
    ]
  },
  {
    name: "Malaysia",
    alpha2Code: "MY",
    alpha3Code: "MYS",
    callingCodes: [
      "60"
    ],
    capital: "Kuala Lumpur",
    region: "Asia",
    latlng: [
      2.5,
      112.5
    ],
    demonym: "Malaysian",
    timezones: [
      "UTC+08:00"
    ],
    flag: "https://flagcdn.com/my.svg",
    currencies: [
      {
        code: "MYR",
        name: "Malaysian ringgit",
        symbol: "RM"
      }
    ]
  },
  {
    name: "Maldives",
    alpha2Code: "MV",
    alpha3Code: "MDV",
    callingCodes: [
      "960"
    ],
    capital: "Malé",
    region: "Asia",
    latlng: [
      3.25,
      73
    ],
    demonym: "Maldivan",
    timezones: [
      "UTC+05:00"
    ],
    flag: "https://flagcdn.com/mv.svg",
    currencies: [
      {
        code: "MVR",
        name: "Maldivian rufiyaa",
        symbol: ".ރ"
      }
    ]
  },
  {
    name: "Mali",
    alpha2Code: "ML",
    alpha3Code: "MLI",
    callingCodes: [
      "223"
    ],
    capital: "Bamako",
    region: "Africa",
    latlng: [
      17,
      -4
    ],
    demonym: "Malian",
    timezones: [
      "UTC"
    ],
    flag: "https://flagcdn.com/ml.svg",
    currencies: [
      {
        code: "XOF",
        name: "West African CFA franc",
        symbol: "Fr"
      }
    ]
  },
  {
    name: "Malta",
    alpha2Code: "MT",
    alpha3Code: "MLT",
    callingCodes: [
      "356"
    ],
    capital: "Valletta",
    region: "Europe",
    latlng: [
      35.83333333,
      14.58333333
    ],
    demonym: "Maltese",
    timezones: [
      "UTC+01:00"
    ],
    flag: "https://flagcdn.com/mt.svg",
    currencies: [
      {
        code: "EUR",
        name: "Euro",
        symbol: "€"
      }
    ]
  },
  {
    name: "Marshall Islands",
    alpha2Code: "MH",
    alpha3Code: "MHL",
    callingCodes: [
      "692"
    ],
    capital: "Majuro",
    region: "Oceania",
    latlng: [
      9,
      168
    ],
    demonym: "Marshallese",
    timezones: [
      "UTC+12:00"
    ],
    flag: "https://flagcdn.com/mh.svg",
    currencies: [
      {
        code: "USD",
        name: "United States dollar",
        symbol: "$"
      }
    ]
  },
  {
    name: "Martinique",
    alpha2Code: "MQ",
    alpha3Code: "MTQ",
    callingCodes: [
      "596"
    ],
    capital: "Fort-de-France",
    region: "Americas",
    latlng: [
      14.666667,
      -61
    ],
    demonym: "French",
    timezones: [
      "UTC-04:00"
    ],
    flag: "https://flagcdn.com/mq.svg",
    currencies: [
      {
        code: "EUR",
        name: "Euro",
        symbol: "€"
      }
    ]
  },
  {
    name: "Mauritania",
    alpha2Code: "MR",
    alpha3Code: "MRT",
    callingCodes: [
      "222"
    ],
    capital: "Nouakchott",
    region: "Africa",
    latlng: [
      20,
      -12
    ],
    demonym: "Mauritanian",
    timezones: [
      "UTC"
    ],
    flag: "https://flagcdn.com/mr.svg",
    currencies: [
      {
        code: "MRO",
        name: "Mauritanian ouguiya",
        symbol: "UM"
      }
    ]
  },
  {
    name: "Mauritius",
    alpha2Code: "MU",
    alpha3Code: "MUS",
    callingCodes: [
      "230"
    ],
    capital: "Port Louis",
    region: "Africa",
    latlng: [
      -20.28333333,
      57.55
    ],
    demonym: "Mauritian",
    timezones: [
      "UTC+04:00"
    ],
    flag: "https://flagcdn.com/mu.svg",
    currencies: [
      {
        code: "MUR",
        name: "Mauritian rupee",
        symbol: "₨"
      }
    ]
  },
  {
    name: "Mayotte",
    alpha2Code: "YT",
    alpha3Code: "MYT",
    callingCodes: [
      "262"
    ],
    capital: "Mamoudzou",
    region: "Africa",
    latlng: [
      -12.83333333,
      45.16666666
    ],
    demonym: "French",
    timezones: [
      "UTC+03:00"
    ],
    flag: "https://flagcdn.com/yt.svg",
    currencies: [
      {
        code: "EUR",
        name: "Euro",
        symbol: "€"
      }
    ]
  },
  {
    name: "Mexico",
    alpha2Code: "MX",
    alpha3Code: "MEX",
    callingCodes: [
      "52"
    ],
    capital: "Mexico City",
    region: "Americas",
    latlng: [
      23,
      -102
    ],
    demonym: "Mexican",
    timezones: [
      "UTC-08:00",
      "UTC-07:00",
      "UTC-06:00"
    ],
    flag: "https://flagcdn.com/mx.svg",
    currencies: [
      {
        code: "MXN",
        name: "Mexican peso",
        symbol: "$"
      }
    ]
  },
  {
    name: "Micronesia (Federated States of)",
    alpha2Code: "FM",
    alpha3Code: "FSM",
    callingCodes: [
      "691"
    ],
    capital: "Palikir",
    region: "Oceania",
    latlng: [
      6.91666666,
      158.25
    ],
    demonym: "Micronesian",
    timezones: [
      "UTC+10:00",
      "UTC+11:00"
    ],
    flag: "https://flagcdn.com/fm.svg",
    currencies: [
      {
        code: "USD",
        name: "United States dollar",
        symbol: "$"
      }
    ]
  },
  {
    name: "Moldova (Republic of)",
    alpha2Code: "MD",
    alpha3Code: "MDA",
    callingCodes: [
      "373"
    ],
    capital: "Chișinău",
    region: "Europe",
    latlng: [
      47,
      29
    ],
    demonym: "Moldovan",
    timezones: [
      "UTC+02:00"
    ],
    flag: "https://flagcdn.com/md.svg",
    currencies: [
      {
        code: "MDL",
        name: "Moldovan leu",
        symbol: "L"
      }
    ]
  },
  {
    name: "Monaco",
    alpha2Code: "MC",
    alpha3Code: "MCO",
    callingCodes: [
      "377"
    ],
    capital: "Monaco",
    region: "Europe",
    latlng: [
      43.73333333,
      7.4
    ],
    demonym: "Monegasque",
    timezones: [
      "UTC+01:00"
    ],
    flag: "https://flagcdn.com/mc.svg",
    currencies: [
      {
        code: "EUR",
        name: "Euro",
        symbol: "€"
      }
    ]
  },
  {
    name: "Mongolia",
    alpha2Code: "MN",
    alpha3Code: "MNG",
    callingCodes: [
      "976"
    ],
    capital: "Ulan Bator",
    region: "Asia",
    latlng: [
      46,
      105
    ],
    demonym: "Mongolian",
    timezones: [
      "UTC+07:00",
      "UTC+08:00"
    ],
    flag: "https://flagcdn.com/mn.svg",
    currencies: [
      {
        code: "MNT",
        name: "Mongolian tögrög",
        symbol: "₮"
      }
    ]
  },
  {
    name: "Montenegro",
    alpha2Code: "ME",
    alpha3Code: "MNE",
    callingCodes: [
      "382"
    ],
    capital: "Podgorica",
    region: "Europe",
    latlng: [
      42.5,
      19.3
    ],
    demonym: "Montenegrin",
    timezones: [
      "UTC+01:00"
    ],
    flag: "https://flagcdn.com/me.svg",
    currencies: [
      {
        code: "EUR",
        name: "Euro",
        symbol: "€"
      }
    ]
  },
  {
    name: "Montserrat",
    alpha2Code: "MS",
    alpha3Code: "MSR",
    callingCodes: [
      "1"
    ],
    capital: "Plymouth",
    region: "Americas",
    latlng: [
      16.75,
      -62.2
    ],
    demonym: "Montserratian",
    timezones: [
      "UTC-04:00"
    ],
    flag: "https://flagcdn.com/ms.svg",
    currencies: [
      {
        code: "XCD",
        name: "East Caribbean dollar",
        symbol: "$"
      }
    ]
  },
  {
    name: "Morocco",
    alpha2Code: "MA",
    alpha3Code: "MAR",
    callingCodes: [
      "212"
    ],
    capital: "Rabat",
    region: "Africa",
    latlng: [
      32,
      -5
    ],
    demonym: "Moroccan",
    timezones: [
      "UTC"
    ],
    flag: "https://flagcdn.com/ma.svg",
    currencies: [
      {
        code: "MAD",
        name: "Moroccan dirham",
        symbol: "د.م."
      }
    ]
  },
  {
    name: "Mozambique",
    alpha2Code: "MZ",
    alpha3Code: "MOZ",
    callingCodes: [
      "258"
    ],
    capital: "Maputo",
    region: "Africa",
    latlng: [
      -18.25,
      35
    ],
    demonym: "Mozambican",
    timezones: [
      "UTC+02:00"
    ],
    flag: "https://flagcdn.com/mz.svg",
    currencies: [
      {
        code: "MZN",
        name: "Mozambican metical",
        symbol: "MT"
      }
    ]
  },
  {
    name: "Myanmar",
    alpha2Code: "MM",
    alpha3Code: "MMR",
    callingCodes: [
      "95"
    ],
    capital: "Naypyidaw",
    region: "Asia",
    latlng: [
      22,
      98
    ],
    demonym: "Burmese",
    timezones: [
      "UTC+06:30"
    ],
    flag: "https://flagcdn.com/mm.svg",
    currencies: [
      {
        code: "MMK",
        name: "Burmese kyat",
        symbol: "Ks"
      }
    ]
  },
  {
    name: "Namibia",
    alpha2Code: "NA",
    alpha3Code: "NAM",
    callingCodes: [
      "264"
    ],
    capital: "Windhoek",
    region: "Africa",
    latlng: [
      -22,
      17
    ],
    demonym: "Namibian",
    timezones: [
      "UTC+01:00"
    ],
    flag: "https://flagcdn.com/na.svg",
    currencies: [
      {
        code: "NAD",
        name: "Namibian dollar",
        symbol: "$"
      },
      {
        code: "ZAR",
        name: "South African rand",
        symbol: "R"
      }
    ]
  },
  {
    name: "Nauru",
    alpha2Code: "NR",
    alpha3Code: "NRU",
    callingCodes: [
      "674"
    ],
    capital: "Yaren",
    region: "Oceania",
    latlng: [
      -0.53333333,
      166.91666666
    ],
    demonym: "Nauruan",
    timezones: [
      "UTC+12:00"
    ],
    flag: "https://flagcdn.com/nr.svg",
    currencies: [
      {
        code: "AUD",
        name: "Australian dollar",
        symbol: "$"
      }
    ]
  },
  {
    name: "Nepal",
    alpha2Code: "NP",
    alpha3Code: "NPL",
    callingCodes: [
      "977"
    ],
    capital: "Kathmandu",
    region: "Asia",
    latlng: [
      28,
      84
    ],
    demonym: "Nepalese",
    timezones: [
      "UTC+05:45"
    ],
    flag: "https://flagcdn.com/np.svg",
    currencies: [
      {
        code: "NPR",
        name: "Nepalese rupee",
        symbol: "₨"
      }
    ]
  },
  {
    name: "Netherlands",
    alpha2Code: "NL",
    alpha3Code: "NLD",
    callingCodes: [
      "31"
    ],
    capital: "Amsterdam",
    region: "Europe",
    latlng: [
      52.5,
      5.75
    ],
    demonym: "Dutch",
    timezones: [
      "UTC-04:00",
      "UTC+01:00"
    ],
    flag: "https://flagcdn.com/nl.svg",
    currencies: [
      {
        code: "EUR",
        name: "Euro",
        symbol: "€"
      }
    ]
  },
  {
    name: "New Caledonia",
    alpha2Code: "NC",
    alpha3Code: "NCL",
    callingCodes: [
      "687"
    ],
    capital: "Nouméa",
    region: "Oceania",
    latlng: [
      -21.5,
      165.5
    ],
    demonym: "New Caledonian",
    timezones: [
      "UTC+11:00"
    ],
    flag: "https://flagcdn.com/nc.svg",
    currencies: [
      {
        code: "XPF",
        name: "CFP franc",
        symbol: "Fr"
      }
    ]
  },
  {
    name: "New Zealand",
    alpha2Code: "NZ",
    alpha3Code: "NZL",
    callingCodes: [
      "64"
    ],
    capital: "Wellington",
    region: "Oceania",
    latlng: [
      -41,
      174
    ],
    demonym: "New Zealander",
    timezones: [
      "UTC-11:00",
      "UTC-10:00",
      "UTC+12:00",
      "UTC+12:45",
      "UTC+13:00"
    ],
    flag: "https://flagcdn.com/nz.svg",
    currencies: [
      {
        code: "NZD",
        name: "New Zealand dollar",
        symbol: "$"
      }
    ]
  },
  {
    name: "Nicaragua",
    alpha2Code: "NI",
    alpha3Code: "NIC",
    callingCodes: [
      "505"
    ],
    capital: "Managua",
    region: "Americas",
    latlng: [
      13,
      -85
    ],
    demonym: "Nicaraguan",
    timezones: [
      "UTC-06:00"
    ],
    flag: "https://flagcdn.com/ni.svg",
    currencies: [
      {
        code: "NIO",
        name: "Nicaraguan córdoba",
        symbol: "C$"
      }
    ]
  },
  {
    name: "Niger",
    alpha2Code: "NE",
    alpha3Code: "NER",
    callingCodes: [
      "227"
    ],
    capital: "Niamey",
    region: "Africa",
    latlng: [
      16,
      8
    ],
    demonym: "Nigerien",
    timezones: [
      "UTC+01:00"
    ],
    flag: "https://flagcdn.com/ne.svg",
    currencies: [
      {
        code: "XOF",
        name: "West African CFA franc",
        symbol: "Fr"
      }
    ]
  },
  {
    name: "Nigeria",
    alpha2Code: "NG",
    alpha3Code: "NGA",
    callingCodes: [
      "234"
    ],
    capital: "Abuja",
    region: "Africa",
    latlng: [
      10,
      8
    ],
    demonym: "Nigerian",
    timezones: [
      "UTC+01:00"
    ],
    flag: "https://flagcdn.com/ng.svg",
    currencies: [
      {
        code: "NGN",
        name: "Nigerian naira",
        symbol: "₦"
      }
    ]
  },
  {
    name: "Niue",
    alpha2Code: "NU",
    alpha3Code: "NIU",
    callingCodes: [
      "683"
    ],
    capital: "Alofi",
    region: "Oceania",
    latlng: [
      -19.03333333,
      -169.86666666
    ],
    demonym: "Niuean",
    timezones: [
      "UTC-11:00"
    ],
    flag: "https://flagcdn.com/nu.svg",
    currencies: [
      {
        code: "NZD",
        name: "New Zealand dollar",
        symbol: "$"
      },
      {
        code: "NZD",
        name: "Niue dollar",
        symbol: "$"
      }
    ]
  },
  {
    name: "Norfolk Island",
    alpha2Code: "NF",
    alpha3Code: "NFK",
    callingCodes: [
      "672"
    ],
    capital: "Kingston",
    region: "Oceania",
    latlng: [
      -29.03333333,
      167.95
    ],
    demonym: "Norfolk Islander",
    timezones: [
      "UTC+11:30"
    ],
    flag: "https://flagcdn.com/nf.svg",
    currencies: [
      {
        code: "AUD",
        name: "Australian dollar",
        symbol: "$"
      }
    ]
  },
  {
    name: "Korea (Democratic People's Republic of)",
    alpha2Code: "KP",
    alpha3Code: "PRK",
    callingCodes: [
      "850"
    ],
    capital: "Pyongyang",
    region: "Asia",
    latlng: [
      40,
      127
    ],
    demonym: "North Korean",
    timezones: [
      "UTC+09:00"
    ],
    flag: "https://flagcdn.com/kp.svg",
    currencies: [
      {
        code: "KPW",
        name: "North Korean won",
        symbol: "₩"
      }
    ]
  },
  {
    name: "Northern Mariana Islands",
    alpha2Code: "MP",
    alpha3Code: "MNP",
    callingCodes: [
      "1"
    ],
    capital: "Saipan",
    region: "Oceania",
    latlng: [
      15.2,
      145.75
    ],
    demonym: "American",
    timezones: [
      "UTC+10:00"
    ],
    flag: "https://flagcdn.com/mp.svg",
    currencies: [
      {
        code: "USD",
        name: "United States dollar",
        symbol: "$"
      }
    ]
  },
  {
    name: "Norway",
    alpha2Code: "NO",
    alpha3Code: "NOR",
    callingCodes: [
      "47"
    ],
    capital: "Oslo",
    region: "Europe",
    latlng: [
      62,
      10
    ],
    demonym: "Norwegian",
    timezones: [
      "UTC+01:00"
    ],
    flag: "https://flagcdn.com/no.svg",
    currencies: [
      {
        code: "NOK",
        name: "Norwegian krone",
        symbol: "kr"
      }
    ]
  },
  {
    name: "Oman",
    alpha2Code: "OM",
    alpha3Code: "OMN",
    callingCodes: [
      "968"
    ],
    capital: "Muscat",
    region: "Asia",
    latlng: [
      21,
      57
    ],
    demonym: "Omani",
    timezones: [
      "UTC+04:00"
    ],
    flag: "https://flagcdn.com/om.svg",
    currencies: [
      {
        code: "OMR",
        name: "Omani rial",
        symbol: "ر.ع."
      }
    ]
  },
  {
    name: "Pakistan",
    alpha2Code: "PK",
    alpha3Code: "PAK",
    callingCodes: [
      "92"
    ],
    capital: "Islamabad",
    region: "Asia",
    latlng: [
      30,
      70
    ],
    demonym: "Pakistani",
    timezones: [
      "UTC+05:00"
    ],
    flag: "https://flagcdn.com/pk.svg",
    currencies: [
      {
        code: "PKR",
        name: "Pakistani rupee",
        symbol: "₨"
      }
    ]
  },
  {
    name: "Palau",
    alpha2Code: "PW",
    alpha3Code: "PLW",
    callingCodes: [
      "680"
    ],
    capital: "Ngerulmud",
    region: "Oceania",
    latlng: [
      7.5,
      134.5
    ],
    demonym: "Palauan",
    timezones: [
      "UTC+09:00"
    ],
    flag: "https://flagcdn.com/pw.svg",
    currencies: [
      {
        code: "USD",
        name: "United States dollar",
        symbol: "$"
      }
    ]
  },
  {
    name: "Palestine, State of",
    alpha2Code: "PS",
    alpha3Code: "PSE",
    callingCodes: [
      "970"
    ],
    capital: "Ramallah",
    region: "Asia",
    latlng: [
      31.9,
      35.2
    ],
    demonym: "Palestinian",
    timezones: [
      "UTC+02:00"
    ],
    flag: "https://flagcdn.com/ps.svg",
    currencies: [
      {
        code: "EGP",
        name: "Egyptian pound",
        symbol: "E£"
      },
      {
        code: "ILS",
        name: "Israeli new shekel",
        symbol: "₪"
      },
      {
        code: "JOD",
        name: "Jordanian dinar",
        symbol: "د.أ"
      }
    ]
  },
  {
    name: "Panama",
    alpha2Code: "PA",
    alpha3Code: "PAN",
    callingCodes: [
      "507"
    ],
    capital: "Panama City",
    region: "Americas",
    latlng: [
      9,
      -80
    ],
    demonym: "Panamanian",
    timezones: [
      "UTC-05:00"
    ],
    flag: "https://flagcdn.com/pa.svg",
    currencies: [
      {
        code: "PAB",
        name: "Panamanian balboa",
        symbol: "B/."
      },
      {
        code: "USD",
        name: "United States dollar",
        symbol: "$"
      }
    ]
  },
  {
    name: "Papua New Guinea",
    alpha2Code: "PG",
    alpha3Code: "PNG",
    callingCodes: [
      "675"
    ],
    capital: "Port Moresby",
    region: "Oceania",
    latlng: [
      -6,
      147
    ],
    demonym: "Papua New Guinean",
    timezones: [
      "UTC+10:00"
    ],
    flag: "https://flagcdn.com/pg.svg",
    currencies: [
      {
        code: "PGK",
        name: "Papua New Guinean kina",
        symbol: "K"
      }
    ]
  },
  {
    name: "Paraguay",
    alpha2Code: "PY",
    alpha3Code: "PRY",
    callingCodes: [
      "595"
    ],
    capital: "Asunción",
    region: "Americas",
    latlng: [
      -23,
      -58
    ],
    demonym: "Paraguayan",
    timezones: [
      "UTC-04:00"
    ],
    flag: "https://flagcdn.com/py.svg",
    currencies: [
      {
        code: "PYG",
        name: "Paraguayan guaraní",
        symbol: "₲"
      }
    ]
  },
  {
    name: "Peru",
    alpha2Code: "PE",
    alpha3Code: "PER",
    callingCodes: [
      "51"
    ],
    capital: "Lima",
    region: "Americas",
    latlng: [
      -10,
      -76
    ],
    demonym: "Peruvian",
    timezones: [
      "UTC-05:00"
    ],
    flag: "https://flagcdn.com/pe.svg",
    currencies: [
      {
        code: "PEN",
        name: "Peruvian sol",
        symbol: "S/."
      }
    ]
  },
  {
    name: "Philippines",
    alpha2Code: "PH",
    alpha3Code: "PHL",
    callingCodes: [
      "63"
    ],
    capital: "Manila",
    region: "Asia",
    latlng: [
      13,
      122
    ],
    demonym: "Filipino",
    timezones: [
      "UTC+08:00"
    ],
    flag: "https://flagcdn.com/ph.svg",
    currencies: [
      {
        code: "PHP",
        name: "Philippine peso",
        symbol: "₱"
      }
    ]
  },
  {
    name: "Pitcairn",
    alpha2Code: "PN",
    alpha3Code: "PCN",
    callingCodes: [
      "64"
    ],
    capital: "Adamstown",
    region: "Oceania",
    latlng: [
      -25.06666666,
      -130.1
    ],
    demonym: "Pitcairn Islander",
    timezones: [
      "UTC-08:00"
    ],
    flag: "https://flagcdn.com/pn.svg",
    currencies: [
      {
        code: "NZD",
        name: "New Zealand dollar",
        symbol: "$"
      },
      {
        code: "PND",
        name: "Pitcairn Islands dollar",
        symbol: "$"
      }
    ]
  },
  {
    name: "Poland",
    alpha2Code: "PL",
    alpha3Code: "POL",
    callingCodes: [
      "48"
    ],
    capital: "Warsaw",
    region: "Europe",
    latlng: [
      52,
      20
    ],
    demonym: "Polish",
    timezones: [
      "UTC+01:00"
    ],
    flag: "https://flagcdn.com/pl.svg",
    currencies: [
      {
        code: "PLN",
        name: "Polish złoty",
        symbol: "zł"
      }
    ]
  },
  {
    name: "Portugal",
    alpha2Code: "PT",
    alpha3Code: "PRT",
    callingCodes: [
      "351"
    ],
    capital: "Lisbon",
    region: "Europe",
    latlng: [
      39.5,
      -8
    ],
    demonym: "Portuguese",
    timezones: [
      "UTC-01:00",
      "UTC"
    ],
    flag: "https://flagcdn.com/pt.svg",
    currencies: [
      {
        code: "EUR",
        name: "Euro",
        symbol: "€"
      }
    ]
  },
  {
    name: "Puerto Rico",
    alpha2Code: "PR",
    alpha3Code: "PRI",
    callingCodes: [
      "1"
    ],
    capital: "San Juan",
    region: "Americas",
    latlng: [
      18.25,
      -66.5
    ],
    demonym: "Puerto Rican",
    timezones: [
      "UTC-04:00"
    ],
    flag: "https://flagcdn.com/pr.svg",
    currencies: [
      {
        code: "USD",
        name: "United States dollar",
        symbol: "$"
      }
    ]
  },
  {
    name: "Qatar",
    alpha2Code: "QA",
    alpha3Code: "QAT",
    callingCodes: [
      "974"
    ],
    capital: "Doha",
    region: "Asia",
    latlng: [
      25.5,
      51.25
    ],
    demonym: "Qatari",
    timezones: [
      "UTC+03:00"
    ],
    flag: "https://flagcdn.com/qa.svg",
    currencies: [
      {
        code: "QAR",
        name: "Qatari riyal",
        symbol: "ر.ق"
      }
    ]
  },
  {
    name: "Republic of Kosovo",
    alpha2Code: "XK",
    alpha3Code: "UNK",
    callingCodes: [
      "383"
    ],
    capital: "Pristina",
    region: "Europe",
    latlng: [
      42.666667,
      21.166667
    ],
    demonym: "Kosovar",
    timezones: [
      "UTC+01:00"
    ],
    flag: "https://flagcdn.com/xk.svg",
    currencies: [
      {
        code: "EUR",
        name: "Euro",
        symbol: "€"
      }
    ]
  },
  {
    name: "Réunion",
    alpha2Code: "RE",
    alpha3Code: "REU",
    callingCodes: [
      "262"
    ],
    capital: "Saint-Denis",
    region: "Africa",
    latlng: [
      -21.15,
      55.5
    ],
    demonym: "French",
    timezones: [
      "UTC+04:00"
    ],
    flag: "https://flagcdn.com/re.svg",
    currencies: [
      {
        code: "EUR",
        name: "Euro",
        symbol: "€"
      }
    ]
  },
  {
    name: "Romania",
    alpha2Code: "RO",
    alpha3Code: "ROU",
    callingCodes: [
      "40"
    ],
    capital: "Bucharest",
    region: "Europe",
    latlng: [
      46,
      25
    ],
    demonym: "Romanian",
    timezones: [
      "UTC+02:00"
    ],
    flag: "https://flagcdn.com/ro.svg",
    currencies: [
      {
        code: "RON",
        name: "Romanian leu",
        symbol: "lei"
      }
    ]
  },
  {
    name: "Russian Federation",
    alpha2Code: "RU",
    alpha3Code: "RUS",
    callingCodes: [
      "7"
    ],
    capital: "Moscow",
    region: "Europe",
    latlng: [
      60,
      100
    ],
    demonym: "Russian",
    timezones: [
      "UTC+03:00",
      "UTC+04:00",
      "UTC+06:00",
      "UTC+07:00",
      "UTC+08:00",
      "UTC+09:00",
      "UTC+10:00",
      "UTC+11:00",
      "UTC+12:00"
    ],
    flag: "https://flagcdn.com/ru.svg",
    currencies: [
      {
        code: "RUB",
        name: "Russian ruble",
        symbol: "₽"
      }
    ]
  },
  {
    name: "Rwanda",
    alpha2Code: "RW",
    alpha3Code: "RWA",
    callingCodes: [
      "250"
    ],
    capital: "Kigali",
    region: "Africa",
    latlng: [
      -2,
      30
    ],
    demonym: "Rwandan",
    timezones: [
      "UTC+02:00"
    ],
    flag: "https://flagcdn.com/rw.svg",
    currencies: [
      {
        code: "RWF",
        name: "Rwandan franc",
        symbol: "Fr"
      }
    ]
  },
  {
    name: "Saint Barthélemy",
    alpha2Code: "BL",
    alpha3Code: "BLM",
    callingCodes: [
      "590"
    ],
    capital: "Gustavia",
    region: "Americas",
    latlng: [
      18.5,
      -63.41666666
    ],
    demonym: "Saint Barthélemy Islander",
    timezones: [
      "UTC-04:00"
    ],
    flag: "https://flagcdn.com/bl.svg",
    currencies: [
      {
        code: "EUR",
        name: "Euro",
        symbol: "€"
      }
    ]
  },
  {
    name: "Saint Helena, Ascension and Tristan da Cunha",
    alpha2Code: "SH",
    alpha3Code: "SHN",
    callingCodes: [
      "290"
    ],
    capital: "Jamestown",
    region: "Africa",
    latlng: [
      -15.95,
      -5.7
    ],
    demonym: "Saint Helenian",
    timezones: [
      "UTC+00:00"
    ],
    flag: "https://flagcdn.com/sh.svg",
    currencies: [
      {
        code: "SHP",
        name: "Saint Helena pound",
        symbol: "£"
      }
    ]
  },
  {
    name: "Saint Kitts and Nevis",
    alpha2Code: "KN",
    alpha3Code: "KNA",
    callingCodes: [
      "1"
    ],
    capital: "Basseterre",
    region: "Americas",
    latlng: [
      17.33333333,
      -62.75
    ],
    demonym: "Kittian and Nevisian",
    timezones: [
      "UTC-04:00"
    ],
    flag: "https://flagcdn.com/kn.svg",
    currencies: [
      {
        code: "XCD",
        name: "East Caribbean dollar",
        symbol: "$"
      }
    ]
  },
  {
    name: "Saint Lucia",
    alpha2Code: "LC",
    alpha3Code: "LCA",
    callingCodes: [
      "1"
    ],
    capital: "Castries",
    region: "Americas",
    latlng: [
      13.88333333,
      -60.96666666
    ],
    demonym: "Saint Lucian",
    timezones: [
      "UTC-04:00"
    ],
    flag: "https://flagcdn.com/lc.svg",
    currencies: [
      {
        code: "XCD",
        name: "East Caribbean dollar",
        symbol: "$"
      }
    ]
  },
  {
    name: "Saint Martin (French part)",
    alpha2Code: "MF",
    alpha3Code: "MAF",
    callingCodes: [
      "590"
    ],
    capital: "Marigot",
    region: "Americas",
    latlng: [
      18.08333333,
      -63.95
    ],
    demonym: "Saint Martin Islander",
    timezones: [
      "UTC-04:00"
    ],
    flag: "https://flagcdn.com/mf.svg",
    currencies: [
      {
        code: "EUR",
        name: "Euro",
        symbol: "€"
      }
    ]
  },
  {
    name: "Saint Pierre and Miquelon",
    alpha2Code: "PM",
    alpha3Code: "SPM",
    callingCodes: [
      "508"
    ],
    capital: "Saint-Pierre",
    region: "Americas",
    latlng: [
      46.83333333,
      -56.33333333
    ],
    demonym: "French",
    timezones: [
      "UTC-03:00"
    ],
    flag: "https://flagcdn.com/pm.svg",
    currencies: [
      {
        code: "EUR",
        name: "Euro",
        symbol: "€"
      }
    ]
  },
  {
    name: "Saint Vincent and the Grenadines",
    alpha2Code: "VC",
    alpha3Code: "VCT",
    callingCodes: [
      "1"
    ],
    capital: "Kingstown",
    region: "Americas",
    latlng: [
      13.25,
      -61.2
    ],
    demonym: "Saint Vincentian",
    timezones: [
      "UTC-04:00"
    ],
    flag: "https://flagcdn.com/vc.svg",
    currencies: [
      {
        code: "XCD",
        name: "East Caribbean dollar",
        symbol: "$"
      }
    ]
  },
  {
    name: "Samoa",
    alpha2Code: "WS",
    alpha3Code: "WSM",
    callingCodes: [
      "685"
    ],
    capital: "Apia",
    region: "Oceania",
    latlng: [
      -13.58333333,
      -172.33333333
    ],
    demonym: "Samoan",
    timezones: [
      "UTC+13:00"
    ],
    flag: "https://flagcdn.com/ws.svg",
    currencies: [
      {
        code: "WST",
        name: "Samoan tālā",
        symbol: "T"
      }
    ]
  },
  {
    name: "San Marino",
    alpha2Code: "SM",
    alpha3Code: "SMR",
    callingCodes: [
      "378"
    ],
    capital: "City of San Marino",
    region: "Europe",
    latlng: [
      43.76666666,
      12.41666666
    ],
    demonym: "Sammarinese",
    timezones: [
      "UTC+01:00"
    ],
    flag: "https://flagcdn.com/sm.svg",
    currencies: [
      {
        code: "EUR",
        name: "Euro",
        symbol: "€"
      }
    ]
  },
  {
    name: "Sao Tome and Principe",
    alpha2Code: "ST",
    alpha3Code: "STP",
    callingCodes: [
      "239"
    ],
    capital: "São Tomé",
    region: "Africa",
    latlng: [
      1,
      7
    ],
    demonym: "Sao Tomean",
    timezones: [
      "UTC"
    ],
    flag: "https://flagcdn.com/st.svg",
    currencies: [
      {
        code: "STD",
        name: "São Tomé and Príncipe dobra",
        symbol: "Db"
      }
    ]
  },
  {
    name: "Saudi Arabia",
    alpha2Code: "SA",
    alpha3Code: "SAU",
    callingCodes: [
      "966"
    ],
    capital: "Riyadh",
    region: "Asia",
    latlng: [
      25,
      45
    ],
    demonym: "Saudi Arabian",
    timezones: [
      "UTC+03:00"
    ],
    flag: "https://flagcdn.com/sa.svg",
    currencies: [
      {
        code: "SAR",
        name: "Saudi riyal",
        symbol: "ر.س"
      }
    ]
  },
  {
    name: "Senegal",
    alpha2Code: "SN",
    alpha3Code: "SEN",
    callingCodes: [
      "221"
    ],
    capital: "Dakar",
    region: "Africa",
    latlng: [
      14,
      -14
    ],
    demonym: "Senegalese",
    timezones: [
      "UTC"
    ],
    flag: "https://flagcdn.com/sn.svg",
    currencies: [
      {
        code: "XOF",
        name: "West African CFA franc",
        symbol: "Fr"
      }
    ]
  },
  {
    name: "Serbia",
    alpha2Code: "RS",
    alpha3Code: "SRB",
    callingCodes: [
      "381"
    ],
    capital: "Belgrade",
    region: "Europe",
    latlng: [
      44,
      21
    ],
    demonym: "Serbian",
    timezones: [
      "UTC+01:00"
    ],
    flag: "https://flagcdn.com/rs.svg",
    currencies: [
      {
        code: "RSD",
        name: "Serbian dinar",
        symbol: "дин."
      }
    ]
  },
  {
    name: "Seychelles",
    alpha2Code: "SC",
    alpha3Code: "SYC",
    callingCodes: [
      "248"
    ],
    capital: "Victoria",
    region: "Africa",
    latlng: [
      -4.58333333,
      55.66666666
    ],
    demonym: "Seychellois",
    timezones: [
      "UTC+04:00"
    ],
    flag: "https://flagcdn.com/sc.svg",
    currencies: [
      {
        code: "SCR",
        name: "Seychellois rupee",
        symbol: "₨"
      }
    ]
  },
  {
    name: "Sierra Leone",
    alpha2Code: "SL",
    alpha3Code: "SLE",
    callingCodes: [
      "232"
    ],
    capital: "Freetown",
    region: "Africa",
    latlng: [
      8.5,
      -11.5
    ],
    demonym: "Sierra Leonean",
    timezones: [
      "UTC"
    ],
    flag: "https://flagcdn.com/sl.svg",
    currencies: [
      {
        code: "SLL",
        name: "Sierra Leonean leone",
        symbol: "Le"
      }
    ]
  },
  {
    name: "Singapore",
    alpha2Code: "SG",
    alpha3Code: "SGP",
    callingCodes: [
      "65"
    ],
    capital: "Singapore",
    region: "Asia",
    latlng: [
      1.36666666,
      103.8
    ],
    demonym: "Singaporean",
    timezones: [
      "UTC+08:00"
    ],
    flag: "https://flagcdn.com/sg.svg",
    currencies: [
      {
        code: "SGD",
        name: "Singapore dollar",
        symbol: "$"
      }
    ]
  },
  {
    name: "Sint Maarten (Dutch part)",
    alpha2Code: "SX",
    alpha3Code: "SXM",
    callingCodes: [
      "1"
    ],
    capital: "Philipsburg",
    region: "Americas",
    latlng: [
      18.033333,
      -63.05
    ],
    demonym: "Dutch",
    timezones: [
      "UTC-04:00"
    ],
    flag: "https://flagcdn.com/sx.svg",
    currencies: [
      {
        code: "ANG",
        name: "Netherlands Antillean guilder",
        symbol: "ƒ"
      }
    ]
  },
  {
    name: "Slovakia",
    alpha2Code: "SK",
    alpha3Code: "SVK",
    callingCodes: [
      "421"
    ],
    capital: "Bratislava",
    region: "Europe",
    latlng: [
      48.66666666,
      19.5
    ],
    demonym: "Slovak",
    timezones: [
      "UTC+01:00"
    ],
    flag: "https://flagcdn.com/sk.svg",
    currencies: [
      {
        code: "EUR",
        name: "Euro",
        symbol: "€"
      }
    ]
  },
  {
    name: "Slovenia",
    alpha2Code: "SI",
    alpha3Code: "SVN",
    callingCodes: [
      "386"
    ],
    capital: "Ljubljana",
    region: "Europe",
    latlng: [
      46.11666666,
      14.81666666
    ],
    demonym: "Slovene",
    timezones: [
      "UTC+01:00"
    ],
    flag: "https://flagcdn.com/si.svg",
    currencies: [
      {
        code: "EUR",
        name: "Euro",
        symbol: "€"
      }
    ]
  },
  {
    name: "Solomon Islands",
    alpha2Code: "SB",
    alpha3Code: "SLB",
    callingCodes: [
      "677"
    ],
    capital: "Honiara",
    region: "Oceania",
    latlng: [
      -8,
      159
    ],
    demonym: "Solomon Islander",
    timezones: [
      "UTC+11:00"
    ],
    flag: "https://flagcdn.com/sb.svg",
    currencies: [
      {
        code: "SBD",
        name: "Solomon Islands dollar",
        symbol: "$"
      }
    ]
  },
  {
    name: "Somalia",
    alpha2Code: "SO",
    alpha3Code: "SOM",
    callingCodes: [
      "252"
    ],
    capital: "Mogadishu",
    region: "Africa",
    latlng: [
      10,
      49
    ],
    demonym: "Somali",
    timezones: [
      "UTC+03:00"
    ],
    flag: "https://flagcdn.com/so.svg",
    currencies: [
      {
        code: "SOS",
        name: "Somali shilling",
        symbol: "Sh"
      }
    ]
  },
  {
    name: "South Africa",
    alpha2Code: "ZA",
    alpha3Code: "ZAF",
    callingCodes: [
      "27"
    ],
    capital: "Pretoria",
    region: "Africa",
    latlng: [
      -29,
      24
    ],
    demonym: "South African",
    timezones: [
      "UTC+02:00"
    ],
    flag: "https://flagcdn.com/za.svg",
    currencies: [
      {
        code: "ZAR",
        name: "South African rand",
        symbol: "R"
      }
    ]
  },
  {
    name: "South Georgia and the South Sandwich Islands",
    alpha2Code: "GS",
    alpha3Code: "SGS",
    callingCodes: [
      "500"
    ],
    capital: "King Edward Point",
    region: "Americas",
    latlng: [
      -54.5,
      -37
    ],
    demonym: "South Georgia and the South Sandwich Islander",
    timezones: [
      "UTC-02:00"
    ],
    flag: "https://flagcdn.com/gs.svg",
    currencies: [
      {
        code: "FKP",
        name: "Falkland Islands Pound",
        symbol: "£"
      }
    ]
  },
  {
    name: "Korea (Republic of)",
    alpha2Code: "KR",
    alpha3Code: "KOR",
    callingCodes: [
      "82"
    ],
    capital: "Seoul",
    region: "Asia",
    latlng: [
      37,
      127.5
    ],
    demonym: "South Korean",
    timezones: [
      "UTC+09:00"
    ],
    flag: "https://flagcdn.com/kr.svg",
    currencies: [
      {
        code: "KRW",
        name: "South Korean won",
        symbol: "₩"
      }
    ]
  },
  {
    name: "Spain",
    alpha2Code: "ES",
    alpha3Code: "ESP",
    callingCodes: [
      "34"
    ],
    capital: "Madrid",
    region: "Europe",
    latlng: [
      40,
      -4
    ],
    demonym: "Spanish",
    timezones: [
      "UTC",
      "UTC+01:00"
    ],
    flag: "https://flagcdn.com/es.svg",
    currencies: [
      {
        code: "EUR",
        name: "Euro",
        symbol: "€"
      }
    ]
  },
  {
    name: "Sri Lanka",
    alpha2Code: "LK",
    alpha3Code: "LKA",
    callingCodes: [
      "94"
    ],
    capital: "Sri Jayawardenepura Kotte",
    region: "Asia",
    latlng: [
      7,
      81
    ],
    demonym: "Sri Lankan",
    timezones: [
      "UTC+05:30"
    ],
    flag: "https://flagcdn.com/lk.svg",
    currencies: [
      {
        code: "LKR",
        name: "Sri Lankan rupee",
        symbol: "Rs"
      }
    ]
  },
  {
    name: "Sudan",
    alpha2Code: "SD",
    alpha3Code: "SDN",
    callingCodes: [
      "249"
    ],
    capital: "Khartoum",
    region: "Africa",
    latlng: [
      15,
      30
    ],
    demonym: "Sudanese",
    timezones: [
      "UTC+03:00"
    ],
    flag: "https://flagcdn.com/sd.svg",
    currencies: [
      {
        code: "SDG",
        name: "Sudanese pound",
        symbol: "ج.س."
      }
    ]
  },
  {
    name: "South Sudan",
    alpha2Code: "SS",
    alpha3Code: "SSD",
    callingCodes: [
      "211"
    ],
    capital: "Juba",
    region: "Africa",
    latlng: [
      7,
      30
    ],
    demonym: "South Sudanese",
    timezones: [
      "UTC+03:00"
    ],
    flag: "https://flagcdn.com/ss.svg",
    currencies: [
      {
        code: "SSP",
        name: "South Sudanese pound",
        symbol: "£"
      }
    ]
  },
  {
    name: "Suriname",
    alpha2Code: "SR",
    alpha3Code: "SUR",
    callingCodes: [
      "597"
    ],
    capital: "Paramaribo",
    region: "Americas",
    latlng: [
      4,
      -56
    ],
    demonym: "Surinamer",
    timezones: [
      "UTC-03:00"
    ],
    flag: "https://flagcdn.com/sr.svg",
    currencies: [
      {
        code: "SRD",
        name: "Surinamese dollar",
        symbol: "$"
      }
    ]
  },
  {
    name: "Svalbard and Jan Mayen",
    alpha2Code: "SJ",
    alpha3Code: "SJM",
    callingCodes: [
      "47"
    ],
    capital: "Longyearbyen",
    region: "Europe",
    latlng: [
      78,
      20
    ],
    demonym: "Norwegian",
    timezones: [
      "UTC+01:00"
    ],
    flag: "https://flagcdn.com/sj.svg",
    currencies: [
      {
        code: "NOK",
        name: "Norwegian krone",
        symbol: "kr"
      }
    ]
  },
  {
    name: "Swaziland",
    alpha2Code: "SZ",
    alpha3Code: "SWZ",
    callingCodes: [
      "268"
    ],
    capital: "Mbabane",
    region: "Africa",
    latlng: [
      -26.5,
      31.5
    ],
    demonym: "Swazi",
    timezones: [
      "UTC+02:00"
    ],
    flag: "https://flagcdn.com/sz.svg",
    currencies: [
      {
        code: "SZL",
        name: "Swazi lilangeni",
        symbol: "L"
      }
    ]
  },
  {
    name: "Sweden",
    alpha2Code: "SE",
    alpha3Code: "SWE",
    callingCodes: [
      "46"
    ],
    capital: "Stockholm",
    region: "Europe",
    latlng: [
      62,
      15
    ],
    demonym: "Swedish",
    timezones: [
      "UTC+01:00"
    ],
    flag: "https://flagcdn.com/se.svg",
    currencies: [
      {
        code: "SEK",
        name: "Swedish krona",
        symbol: "kr"
      }
    ]
  },
  {
    name: "Switzerland",
    alpha2Code: "CH",
    alpha3Code: "CHE",
    callingCodes: [
      "41"
    ],
    capital: "Bern",
    region: "Europe",
    latlng: [
      47,
      8
    ],
    demonym: "Swiss",
    timezones: [
      "UTC+01:00"
    ],
    flag: "https://flagcdn.com/ch.svg",
    currencies: [
      {
        code: "CHF",
        name: "Swiss franc",
        symbol: "Fr"
      }
    ]
  },
  {
    name: "Syrian Arab Republic",
    alpha2Code: "SY",
    alpha3Code: "SYR",
    callingCodes: [
      "963"
    ],
    capital: "Damascus",
    region: "Asia",
    latlng: [
      35,
      38
    ],
    demonym: "Syrian",
    timezones: [
      "UTC+02:00"
    ],
    flag: "https://flagcdn.com/sy.svg",
    currencies: [
      {
        code: "SYP",
        name: "Syrian pound",
        symbol: "£"
      }
    ]
  },
  {
    name: "Taiwan",
    alpha2Code: "TW",
    alpha3Code: "TWN",
    callingCodes: [
      "886"
    ],
    capital: "Taipei",
    region: "Asia",
    latlng: [
      23.5,
      121
    ],
    demonym: "Taiwanese",
    timezones: [
      "UTC+08:00"
    ],
    flag: "https://flagcdn.com/tw.svg",
    currencies: [
      {
        code: "TWD",
        name: "New Taiwan dollar",
        symbol: "$"
      }
    ]
  },
  {
    name: "Tajikistan",
    alpha2Code: "TJ",
    alpha3Code: "TJK",
    callingCodes: [
      "992"
    ],
    capital: "Dushanbe",
    region: "Asia",
    latlng: [
      39,
      71
    ],
    demonym: "Tadzhik",
    timezones: [
      "UTC+05:00"
    ],
    flag: "https://flagcdn.com/tj.svg",
    currencies: [
      {
        code: "TJS",
        name: "Tajikistani somoni",
        symbol: "ЅМ"
      }
    ]
  },
  {
    name: "Tanzania, United Republic of",
    alpha2Code: "TZ",
    alpha3Code: "TZA",
    callingCodes: [
      "255"
    ],
    capital: "Dodoma",
    region: "Africa",
    latlng: [
      -6,
      35
    ],
    demonym: "Tanzanian",
    timezones: [
      "UTC+03:00"
    ],
    flag: "https://flagcdn.com/tz.svg",
    currencies: [
      {
        code: "TZS",
        name: "Tanzanian shilling",
        symbol: "Sh"
      }
    ]
  },
  {
    name: "Thailand",
    alpha2Code: "TH",
    alpha3Code: "THA",
    callingCodes: [
      "66"
    ],
    capital: "Bangkok",
    region: "Asia",
    latlng: [
      15,
      100
    ],
    demonym: "Thai",
    timezones: [
      "UTC+07:00"
    ],
    flag: "https://flagcdn.com/th.svg",
    currencies: [
      {
        code: "THB",
        name: "Thai baht",
        symbol: "฿"
      }
    ]
  },
  {
    name: "Timor-Leste",
    alpha2Code: "TL",
    alpha3Code: "TLS",
    callingCodes: [
      "670"
    ],
    capital: "Dili",
    region: "Asia",
    latlng: [
      -8.83333333,
      125.91666666
    ],
    demonym: "East Timorese",
    timezones: [
      "UTC+09:00"
    ],
    flag: "https://flagcdn.com/tl.svg",
    currencies: [
      {
        code: "USD",
        name: "United States Dollar",
        symbol: "$"
      }
    ]
  },
  {
    name: "Togo",
    alpha2Code: "TG",
    alpha3Code: "TGO",
    callingCodes: [
      "228"
    ],
    capital: "Lomé",
    region: "Africa",
    latlng: [
      8,
      1.16666666
    ],
    demonym: "Togolese",
    timezones: [
      "UTC"
    ],
    flag: "https://flagcdn.com/tg.svg",
    currencies: [
      {
        code: "XOF",
        name: "West African CFA franc",
        symbol: "Fr"
      }
    ]
  },
  {
    name: "Tokelau",
    alpha2Code: "TK",
    alpha3Code: "TKL",
    callingCodes: [
      "690"
    ],
    capital: "Fakaofo",
    region: "Oceania",
    latlng: [
      -9,
      -172
    ],
    demonym: "Tokelauan",
    timezones: [
      "UTC+13:00"
    ],
    flag: "https://flagcdn.com/tk.svg",
    currencies: [
      {
        code: "NZD",
        name: "New Zealand dollar",
        symbol: "$"
      }
    ]
  },
  {
    name: "Tonga",
    alpha2Code: "TO",
    alpha3Code: "TON",
    callingCodes: [
      "676"
    ],
    capital: "Nuku'alofa",
    region: "Oceania",
    latlng: [
      -20,
      -175
    ],
    demonym: "Tongan",
    timezones: [
      "UTC+13:00"
    ],
    flag: "https://flagcdn.com/to.svg",
    currencies: [
      {
        code: "TOP",
        name: "Tongan paʻanga",
        symbol: "T$"
      }
    ]
  },
  {
    name: "Trinidad and Tobago",
    alpha2Code: "TT",
    alpha3Code: "TTO",
    callingCodes: [
      "1"
    ],
    capital: "Port of Spain",
    region: "Americas",
    latlng: [
      11,
      -61
    ],
    demonym: "Trinidadian",
    timezones: [
      "UTC-04:00"
    ],
    flag: "https://flagcdn.com/tt.svg",
    currencies: [
      {
        code: "TTD",
        name: "Trinidad and Tobago dollar",
        symbol: "$"
      }
    ]
  },
  {
    name: "Tunisia",
    alpha2Code: "TN",
    alpha3Code: "TUN",
    callingCodes: [
      "216"
    ],
    capital: "Tunis",
    region: "Africa",
    latlng: [
      34,
      9
    ],
    demonym: "Tunisian",
    timezones: [
      "UTC+01:00"
    ],
    flag: "https://flagcdn.com/tn.svg",
    currencies: [
      {
        code: "TND",
        name: "Tunisian dinar",
        symbol: "د.ت"
      }
    ]
  },
  {
    name: "Turkey",
    alpha2Code: "TR",
    alpha3Code: "TUR",
    callingCodes: [
      "90"
    ],
    capital: "Ankara",
    region: "Asia",
    latlng: [
      39,
      35
    ],
    demonym: "Turkish",
    timezones: [
      "UTC+03:00"
    ],
    flag: "https://flagcdn.com/tr.svg",
    currencies: [
      {
        code: "TRY",
        name: "Turkish lira",
        symbol: "₺"
      }
    ]
  },
  {
    name: "Turkmenistan",
    alpha2Code: "TM",
    alpha3Code: "TKM",
    callingCodes: [
      "993"
    ],
    capital: "Ashgabat",
    region: "Asia",
    latlng: [
      40,
      60
    ],
    demonym: "Turkmen",
    timezones: [
      "UTC+05:00"
    ],
    flag: "https://flagcdn.com/tm.svg",
    currencies: [
      {
        code: "TMT",
        name: "Turkmenistan manat",
        symbol: "m"
      }
    ]
  },
  {
    name: "Turks and Caicos Islands",
    alpha2Code: "TC",
    alpha3Code: "TCA",
    callingCodes: [
      "1"
    ],
    capital: "Cockburn Town",
    region: "Americas",
    latlng: [
      21.75,
      -71.58333333
    ],
    demonym: "Turks and Caicos Islander",
    timezones: [
      "UTC-04:00"
    ],
    flag: "https://flagcdn.com/tc.svg",
    currencies: [
      {
        code: "USD",
        name: "United States dollar",
        symbol: "$"
      }
    ]
  },
  {
    name: "Tuvalu",
    alpha2Code: "TV",
    alpha3Code: "TUV",
    callingCodes: [
      "688"
    ],
    capital: "Funafuti",
    region: "Oceania",
    latlng: [
      -8,
      178
    ],
    demonym: "Tuvaluan",
    timezones: [
      "UTC+12:00"
    ],
    flag: "https://flagcdn.com/tv.svg",
    currencies: [
      {
        code: "AUD",
        name: "Australian dollar",
        symbol: "$"
      },
      {
        code: "TVD[G]",
        name: "Tuvaluan dollar",
        symbol: "$"
      }
    ]
  },
  {
    name: "Uganda",
    alpha2Code: "UG",
    alpha3Code: "UGA",
    callingCodes: [
      "256"
    ],
    capital: "Kampala",
    region: "Africa",
    latlng: [
      1,
      32
    ],
    demonym: "Ugandan",
    timezones: [
      "UTC+03:00"
    ],
    flag: "https://flagcdn.com/ug.svg",
    currencies: [
      {
        code: "UGX",
        name: "Ugandan shilling",
        symbol: "Sh"
      }
    ]
  },
  {
    name: "Ukraine",
    alpha2Code: "UA",
    alpha3Code: "UKR",
    callingCodes: [
      "380"
    ],
    capital: "Kyiv",
    region: "Europe",
    latlng: [
      49,
      32
    ],
    demonym: "Ukrainian",
    timezones: [
      "UTC+02:00"
    ],
    flag: "https://flagcdn.com/ua.svg",
    currencies: [
      {
        code: "UAH",
        name: "Ukrainian hryvnia",
        symbol: "₴"
      }
    ]
  },
  {
    name: "United Arab Emirates",
    alpha2Code: "AE",
    alpha3Code: "ARE",
    callingCodes: [
      "971"
    ],
    capital: "Abu Dhabi",
    region: "Asia",
    latlng: [
      24,
      54
    ],
    demonym: "Emirati",
    timezones: [
      "UTC+04:00"
    ],
    flag: "https://flagcdn.com/ae.svg",
    currencies: [
      {
        code: "AED",
        name: "United Arab Emirates dirham",
        symbol: "د.إ"
      }
    ]
  },
  {
    name: "United Kingdom of Great Britain and Northern Ireland",
    alpha2Code: "GB",
    alpha3Code: "GBR",
    callingCodes: [
      "44"
    ],
    capital: "London",
    region: "Europe",
    latlng: [
      54,
      -2
    ],
    demonym: "British",
    timezones: [
      "UTC-08:00",
      "UTC-05:00",
      "UTC-04:00",
      "UTC-03:00",
      "UTC-02:00",
      "UTC",
      "UTC+01:00",
      "UTC+02:00",
      "UTC+06:00"
    ],
    flag: "https://flagcdn.com/gb.svg",
    currencies: [
      {
        code: "GBP",
        name: "British pound",
        symbol: "£"
      }
    ]
  },
  {
    name: "United States of America",
    alpha2Code: "US",
    alpha3Code: "USA",
    callingCodes: [
      "1"
    ],
    capital: "Washington, D.C.",
    region: "Americas",
    latlng: [
      38,
      -97
    ],
    demonym: "American",
    timezones: [
      "UTC-12:00",
      "UTC-11:00",
      "UTC-10:00",
      "UTC-09:00",
      "UTC-08:00",
      "UTC-07:00",
      "UTC-06:00",
      "UTC-05:00",
      "UTC-04:00",
      "UTC+10:00",
      "UTC+12:00"
    ],
    flag: "https://flagcdn.com/us.svg",
    currencies: [
      {
        code: "USD",
        name: "United States dollar",
        symbol: "$"
      }
    ]
  },
  {
    name: "Uruguay",
    alpha2Code: "UY",
    alpha3Code: "URY",
    callingCodes: [
      "598"
    ],
    capital: "Montevideo",
    region: "Americas",
    latlng: [
      -33,
      -56
    ],
    demonym: "Uruguayan",
    timezones: [
      "UTC-03:00"
    ],
    flag: "https://flagcdn.com/uy.svg",
    currencies: [
      {
        code: "UYU",
        name: "Uruguayan peso",
        symbol: "$"
      }
    ]
  },
  {
    name: "Uzbekistan",
    alpha2Code: "UZ",
    alpha3Code: "UZB",
    callingCodes: [
      "998"
    ],
    capital: "Tashkent",
    region: "Asia",
    latlng: [
      41,
      64
    ],
    demonym: "Uzbekistani",
    timezones: [
      "UTC+05:00"
    ],
    flag: "https://flagcdn.com/uz.svg",
    currencies: [
      {
        code: "UZS",
        name: "Uzbekistani so'm",
        symbol: "so'm"
      }
    ]
  },
  {
    name: "Vanuatu",
    alpha2Code: "VU",
    alpha3Code: "VUT",
    callingCodes: [
      "678"
    ],
    capital: "Port Vila",
    region: "Oceania",
    latlng: [
      -16,
      167
    ],
    demonym: "Ni-Vanuatu",
    timezones: [
      "UTC+11:00"
    ],
    flag: "https://flagcdn.com/vu.svg",
    currencies: [
      {
        code: "VUV",
        name: "Vanuatu vatu",
        symbol: "Vt"
      }
    ]
  },
  {
    name: "Venezuela (Bolivarian Republic of)",
    alpha2Code: "VE",
    alpha3Code: "VEN",
    callingCodes: [
      "58"
    ],
    capital: "Caracas",
    region: "Americas",
    latlng: [
      8,
      -66
    ],
    demonym: "Venezuelan",
    timezones: [
      "UTC-04:00"
    ],
    flag: "https://flagcdn.com/ve.svg",
    currencies: [
      {
        code: "VEF",
        name: "Venezuelan bolívar",
        symbol: "Bs S"
      }
    ]
  },
  {
    name: "Vietnam",
    alpha2Code: "VN",
    alpha3Code: "VNM",
    callingCodes: [
      "84"
    ],
    capital: "Hanoi",
    region: "Asia",
    latlng: [
      16.16666666,
      107.83333333
    ],
    demonym: "Vietnamese",
    timezones: [
      "UTC+07:00"
    ],
    flag: "https://flagcdn.com/vn.svg",
    currencies: [
      {
        code: "VND",
        name: "Vietnamese đồng",
        symbol: "₫"
      }
    ]
  },
  {
    name: "Wallis and Futuna",
    alpha2Code: "WF",
    alpha3Code: "WLF",
    callingCodes: [
      "681"
    ],
    capital: "Mata-Utu",
    region: "Oceania",
    latlng: [
      -13.3,
      -176.2
    ],
    demonym: "Wallis and Futuna Islander",
    timezones: [
      "UTC+12:00"
    ],
    flag: "https://flagcdn.com/wf.svg",
    currencies: [
      {
        code: "XPF",
        name: "CFP franc",
        symbol: "Fr"
      }
    ]
  },
  {
    name: "Western Sahara",
    alpha2Code: "EH",
    alpha3Code: "ESH",
    callingCodes: [
      "212"
    ],
    capital: "El Aaiún",
    region: "Africa",
    latlng: [
      24.5,
      -13
    ],
    demonym: "Sahrawi",
    timezones: [
      "UTC+00:00"
    ],
    flag: "https://flagcdn.com/eh.svg",
    currencies: [
      {
        code: "MAD",
        name: "Moroccan dirham",
        symbol: "د.م."
      },
      {
        code: "DZD",
        name: "Algerian dinar",
        symbol: "د.ج"
      }
    ]
  },
  {
    name: "Yemen",
    alpha2Code: "YE",
    alpha3Code: "YEM",
    callingCodes: [
      "967"
    ],
    capital: "Sana'a",
    region: "Asia",
    latlng: [
      15,
      48
    ],
    demonym: "Yemeni",
    timezones: [
      "UTC+03:00"
    ],
    flag: "https://flagcdn.com/ye.svg",
    currencies: [
      {
        code: "YER",
        name: "Yemeni rial",
        symbol: "﷼"
      }
    ]
  },
  {
    name: "Zambia",
    alpha2Code: "ZM",
    alpha3Code: "ZMB",
    callingCodes: [
      "260"
    ],
    capital: "Lusaka",
    region: "Africa",
    latlng: [
      -15,
      30
    ],
    demonym: "Zambian",
    timezones: [
      "UTC+02:00"
    ],
    flag: "https://flagcdn.com/zm.svg",
    currencies: [
      {
        code: "ZMW",
        name: "Zambian kwacha",
        symbol: "ZK"
      }
    ]
  },
  {
    name: "Zimbabwe",
    alpha2Code: "ZW",
    alpha3Code: "ZWE",
    callingCodes: [
      "263"
    ],
    capital: "Harare",
    region: "Africa",
    latlng: [
      -20,
      30
    ],
    demonym: "Zimbabwean",
    timezones: [
      "UTC+02:00"
    ],
    flag: "https://flagcdn.com/zw.svg",
    currencies: [
      {
        code: "ZMW",
        name: "Zambian kwacha",
        symbol: "K"
      }
    ]
  }
], Na = (R) => {
  const M = () => {
    let y = {};
    switch (R.point) {
      case "up":
        y = {
          position: "absolute",
          color: "#696969",
          right: "20px",
          transition: "all 0.3s",
          transform: "rotate(180deg)",
          height: "16px"
        };
        break;
      case "down":
        y = {
          position: "absolute",
          right: "20px",
          color: "#696969",
          transition: "all 0.3s",
          height: "16px"
        };
        break;
      case "up_white":
        y = {
          position: "absolute",
          left: "10px",
          top: "-10px",
          transform: "rotate(180deg)",
          color: "#fff",
          height: "16px"
        };
        break;
    }
    return y;
  };
  return /* @__PURE__ */ u.jsx(
    "svg",
    {
      "aria-hidden": "true",
      focusable: "false",
      "data-prefix": "fas",
      "data-icon": "caret-down",
      className: "svg-inline--fa fa-caret-down fa-w-10",
      role: "img",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 320 512",
      height: "18px",
      color: R.color,
      style: M(),
      children: /* @__PURE__ */ u.jsx(
        "path",
        {
          fill: "currentColor",
          d: `M31.3 192h257.3c17.8 0 26.7
            21.5 14.1 34.1L174.1 354.8c-7.8
            7.8-20.5 7.8-28.3 0L17.2 226.1C4.6
            213.5 13.5 192 31.3 192z`
        }
      )
    }
  );
}, be = "_container_1c03y_8", ve = "_dropdown_1c03y_15", Ue = "_dropdown_items_wrapper_1c03y_27", Ae = "_dropdown_items_1c03y_27", Se = "_input_wrapper_1c03y_44", Ee = "_country_search_1c03y_50", ze = "_dropdown_item_1c03y_27", Re = "_dropdown_item_title_1c03y_100", Me = "_selected_country_1c03y_109", De = "_country_flag_1c03y_116", A = {
  container: be,
  dropdown: ve,
  dropdown_items_wrapper: Ue,
  dropdown_items: Ae,
  input_wrapper: Se,
  country_search: Ee,
  dropdown_item: ze,
  dropdown_item_title: Re,
  selected_country: Me,
  country_flag: De
}, la = Te;
function Be({ defaultCountry: R, onSelect: M }) {
  const [y, S] = oa(la), [h, w] = oa(), [b, E] = oa(!1), d = he(null), P = (o) => {
    const U = y.filter(
      (O) => O.alpha2Code.toLowerCase() === o.toLowerCase()
    );
    w(U[0]);
  }, g = () => {
    E(!b);
  }, v = (o) => {
    const U = {
      name: o == null ? void 0 : o.name,
      code: o == null ? void 0 : o.alpha2Code,
      code2: o == null ? void 0 : o.alpha3Code,
      capital: (o == null ? void 0 : o.capital) || "",
      region: o == null ? void 0 : o.region,
      citizen: o == null ? void 0 : o.demonym,
      flagUrl: o == null ? void 0 : o.flag,
      callingCodes: (o == null ? void 0 : o.callingCodes) || [],
      currencies: (o == null ? void 0 : o.currencies) || [],
      timezones: (o == null ? void 0 : o.timezones) || [],
      latlng: (o == null ? void 0 : o.latlng) || []
    };
    w(o), M(U), g();
  }, D = (o) => {
    const U = o.target.value.toLowerCase().trim();
    if (U === "") {
      S(la);
      return;
    }
    const O = y.filter((B) => B.name.toLowerCase().startsWith(U));
    S(O);
  }, F = (o) => {
    var U;
    d.current && !((U = d.current) != null && U.contains(o.target)) && E(!1);
  };
  return Pa(() => {
    b || S(la);
  }, [b]), Pa(() => {
    P(R), document.addEventListener("mousedown", F);
  }, [R]), /* @__PURE__ */ u.jsxs("div", { className: A.container, ref: d, children: [
    /* @__PURE__ */ u.jsxs("div", { className: A.dropdown, onClick: g, children: [
      /* @__PURE__ */ u.jsx(
        "img",
        {
          className: A.country_flag,
          src: h == null ? void 0 : h.flag,
          alt: h == null ? void 0 : h.name
        }
      ),
      /* @__PURE__ */ u.jsx("span", { className: A.selected_country, children: h == null ? void 0 : h.alpha2Code }),
      /* @__PURE__ */ u.jsx(Na, { point: b ? "up" : "down" })
    ] }),
    b && /* @__PURE__ */ u.jsxs("div", { className: A.dropdown_items_wrapper, children: [
      /* @__PURE__ */ u.jsx(Na, { point: "up_white" }),
      /* @__PURE__ */ u.jsx("div", { className: A.input_wrapper, children: /* @__PURE__ */ u.jsx(
        "input",
        {
          onChange: (o) => D(o),
          className: A.country_search,
          type: "text",
          placeholder: "search country here",
          autoFocus: !0
        }
      ) }),
      /* @__PURE__ */ u.jsx("div", { className: A.dropdown_items, children: y.map((o) => /* @__PURE__ */ u.jsxs(
        "div",
        {
          onClick: () => v(o),
          className: A.dropdown_item,
          children: [
            /* @__PURE__ */ u.jsx("img", { className: A.country_flag, src: o.flag, alt: "" }),
            /* @__PURE__ */ u.jsxs("span", { className: A.dropdown_item_title, children: [
              " ",
              o.name
            ] })
          ]
        },
        o.name
      )) })
    ] })
  ] });
}
export {
  Be as default
};
